import { SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION } from "constants";

export const locale = {
  lang: 'TRTR',
  data: {
    loginButton: "Giriş",
    userName: "Kullanıcı Adı",
    emailCode: "Email Kodu",
    pass: "Parola",
    remember: "Beni Hatırla",
    forgotPass: "Parolayı Unuttum",
    modules: "Modüller",
    generic: "Genel",
    search: "Ara",
    logout: "Çıkış",
    waitingJob: "Bekleyen İşlerim",
    myStarted: "Başlattığım",
    myIncluded: "Dahil Olduğum",
    myCompleted: "Tamamladığım İşler",
    jobListMessageArea: "İş listesi mesaj alanı",
    jobList: "İş Listesi",
    formNo: "Form No",
    starter: "Başlatan",
    generateLink: "Link üret",
    assigned: "Atanan",
    timeoutDate: "Zaman Aşımı Tarihi",
    startDate: "Başlangıç Tarihi",
    processing: "İşleniyor",
    you: "sen",
    history: "Geçmiş",
    description: "Açıklama",
    date: "Tarih",
    growShrink: "Büyüt/Küçült",
    close: "Kapat",
    gridReset: "Grid Ayarlarını Sıfırla",
    columnSelect: "Sütun Seçimi",
    jobName: "İş Adı",
    keyword: "Anahtar Kelime",
    completion: "Tamamlama",
    all: "Tümü",
    completedDate: "Bitiş Tarihi",
    completions: "Tamamlananlar",
    ongoing: "Devam Eden",
    formName: "Form Adı",
    sunday: "Pazar",
    monday: "Pazartesi",
    tuesday: "Salı",
    wednesday: "Çarşamba",
    thursday: "Perşembe",
    friday: "Cuma",
    saturday: "Cumartesi",
    pdfExport: "PDF Dışa Aktar",
    sendPassword: "Parolamı Gönder",
    assignedDate: "Atama Tarihi",
    events: "Olaylar",
    new: "Yeni",
    save: "Kaydet",
    formula: "Formül",
    selectDataSource: "Veri Kaynağı Seç",
    requiredField: "Zorunlu Alan",
    makeRequiredField: "Zorunlu Alan Yap",
    suffix: "Ek",
    valueColumn: "Değer Sütunu",
    showLength: "Sütunlardaki Görev Sayısını Göster",
    clearButton: "Temizle Butonu",
    allCaps: "Tüm Harfler Büyük",
    autoAsc: "Otomatik Artan",
    width: "Genişlik",
    length: "Uzunluk",
    functions: "Fonksiyonlar",
    selectElement: "Eleman Seç",
    selectColumn: "Sütun Seç",
    edit: "Düzenle",
    changeEventActions: "Olay Eylemlerini Değiştir",
    barcode: "Barkod",
    systemInfo: "Sistem Bilgisi",
    prefix: "Ön ek",
    max: "Maksimum",
    showMinMaxInfo: "Minimum ve Maksimum Bilgisini Göster",
    selectUser: "Kullanıcı Seç",
    spinButton: "Spin Butonu",
    numberIncDecButton: "Artır-Azalt Sayı Butonu",
    decimal: "Ondalık Sayı",
    numeral: "Sayı",
    wrongFormat: "Yanlış biçimi girdiniz",
    height: "Yükseklik",
    microphone: "Mikrofon",
    notifyDataReset: "Veri Sıfırlama",
    data: "Veri",
    dynamicData: "Dinamik Veri",
    manualData: "Elle Girilen Veri",
    selectDataGrid: "Veri Tablosu Seç",
    overrideUserChange: "Kullanıcı Değişikliklerini Geçersiz Kıl",
    textColumn: "Metin Sütunu",
    makeInitialValue: "İlk Değer Varsayılan Olsun",
    multiselectPickerMode: "Çoklu seçim arayüzü",
    multiselectPickerTable: "Tablo (tüm kolonlar, onay ile)",
    multiselectPickerList: "Liste (TagBox, anında seçim)",
    undo: "Geri Al",
    copy: "Kopyala",
    preview: "Önizleme",
    delete: "Sil",
    cancel: "İptal",
    languageSettings: "Dil Ayarları",
    messageSqlLinkDeleted: "Veriyi el ile eklediğiniz için SQL komut dosyası ve bağlantı adresi silinecek! Devam etmek istiyor musunuz?",
    messageSqlLinkDeletedForMenu: "Veriyi menu olarak seçtiğiniz için SQL komut dosyası ve bağlantı adresi silinecek! Devam etmek istiyor musunuz?",
    permissions: "İzinler",
    objectid: "Nesne Kimliği",
    fontSize: "Yazı Boyutu",
    fontWidth: "Yazı Genişliği",
    fontStyle: "Yazı Stili",
    labelMode: "Etiket Modu",
    normal: "Normal",
    static: "Statik",
    floating: "Yüzen",
    outside: "Dış",
    underline: "Altı Çizili",
    textColor: "Metin Rengi",
    visibility: "Görünürlük",
    textAlignment: "Metin Hizalama",
    settings: "Ayarlar",
    messageUnsaved: "Değişiklikleri kaydetmeden çıkmak istediğinizden emin misiniz?",
    warning: "Uyarı",
    success: "Başarılı",
    error: "Hata",
    userAuthorizations: "Kullanıcı Yetkilendirmeleri",
    formPreferences: "Form Tercihleri",
    formOpeningevent: "Form Açılış Olayı",
    formOpenLocationEvent: "Form Açılış Koordinat Etkinliği",
    enableFormOpenLocationEvent: "Form açıldığında koordinatları kaydet",
    latitude: "Enlem",
    longitude: "Boylam",
    chooseConnectionAddress: "Bağlantı Adresini Seç",
    selectPriorty: "Öncelik Seç",
    loadingEditor: "Düzenleyici Yükleniyor...",
    showAddButton: "Satır Ekle Butonu Göster",
    update: "Güncelle",
    connectionID: "Bağlantı Kimliği",
    formPreview: "Form Önizleme",
    nameDisplayedform: "Görüntülenen Form Adı",
    formNamevariable: "Form Adı Değişkeni",
    category: "Kategori",
    formColor: "Form Rengi",
    generalForm: "Genel Form",
    saveForm: "Formu Kaydet",
    messageNeworupdate: "Varolan form üzerinde yaptığınız değişiklikler silinecek. Devam etmek istiyor musunuz?",
    messageDelete: "Formu silmek istediğinizden emin misiniz?",
    toastDeleted: "Form Silindi",
    toastError: "Üzgünüz, işlem sırasında bir hata oluştu",
    alertDifferentID: "Bu kimlik başka bir yerde kullanılmış, lütfen farklı bir kimlik belirtin.",
    confirmChanges: "Değişiklikleri Onayla",
    toastUserpermission: "Kullanıcının form tasarım izni yok.",
    toastCodeeditor: "Kod düzenleyici zaten mevcut",
    messageDeletesure: "Bu bileşen içindeki öğeler silinecek",
    messageSure: "Emin misiniz?",
    successful: "Başarılı",
    toastFormupdate: "Form Güncellendi",
    toastMistake: "Üzgünüm, işlem sırasında bir hata oluştu",
    toastSaved: "Kaydedildi",
    toastCopied: "Kopyalandı",
    toastEmptyFormMessage: "Henüz form öğesi eklenmedi",
    toastGiveName: "Lütfen formunuza bir ad verin",
    toastGiveVariableName: "Lütfen form adı değişkenine bir ad verin",
    toastVariableNameNumberWarning: "Değişken adı rakamla başlayamaz",
    formCopy: "Formu Kopyala",
    messageButtonDelete: "Bu düğmeyi silmek istediğinizden emin misiniz?",
    noDataFound: "Veri Bulunamadı",
    language: "Dil",
    filterDatagrid: "Veri Tablosu Filtreleme",
    addManualData: "Çalışma Zamanında El İle Veri Ekle",
    dateFormat: "Tarih Biçimi",
    messageSqlLinkDelete: "Veriyi el ile eklediğiniz için SQL komut dosyası ve bağlantı adresi silinecek! Devam etmek istiyor musunuz?",
    timeOption: "Saat Seçeneği",
    defaultTodaysDate: "Varsayılan bugünün tarihi",
    defaultEmptyTime: "Saat alanı boş gelsin",
    dateRange: "Tarih Aralığı",
    minToday: "Minimum Bugün",
    maxToday: "Maksimum Bugün",
    dateRangeDay: "Tarih Aralığı (Gün)",
    enterDateRangeValue: "Tarih aralığı değerini girin",
    imageIdColumn: "Kimlik Sütunu",
    statusSettings: "Durum Ayarları",
    active: "Aktif",
    passive: "Pasif",
    enable: "Etkinleştir",
    disable: "Devre Dışı Bırak",
    visible: "Görünür",
    invisible: "Görünmez",
    items: "Öğeler",
    showItems: "Öğeleri Göster",
    array: "Dizi",
    letLabelAppear: "Etiket Göster",
    add: "Ekle",
    horizontal: "Yatay",
    vertical: "Dikey",
    text: "Metin",
    alertFillRequiredFields: "Lütfen zorunlu alanları doldurun",
    alertSignatureField: "İmza alanı boş olamaz",
    messageApproveTransaction: "İşlemi onaylıyor musunuz?",
    button: "Düğme",
    reasonforRefusal: "Red Nedeni",
    enterReasonRejection: "Red Nedenini Girin",
    reject: "Reddet",
    addDeleteButton: "Düğme Ekle/Sil",
    showBorder: "Sınır Gözüksün",
    buttons: "Düğmeler",
    clean: "Temizle",
    buttonSettings: "Düğme Ayarları",
    saveLocation: "Kayıt Konumu",
    paymentButton: "Ödeme Düğmesi",
    paymentProvider: "Ödeme Sağlayıcısı",
    price: "Fiyat",
    numberOfInstallments: "Taksit Sayısı",
    descriptionField: "Açıklama Alanı",
    current: "Mevcut",
    currentForm: "Mevcut Form",
    name: "Ad",
    surname: "Soyad",
    country: "Ülke",
    city: "Şehir",
    address: "Adres",
    authorizations: "Yetkilendirmeler",
    users: "Kullanıcılar",
    user: "Kullanıcı",
    givePermission: "Yetkilendir",
    otherPermission: "Diğer Yetkilendirmeler",
    groups: "Gruplar",
    group: "Grup",
    saveandSend: "Kaydet ve Gönder",
    approve: "Onayla",
    sendBack: "Geri Gönder",
    deslineAndEnd: "Reddet ve Bitir",
    complete: "Tamamlandı",
    blue: "Mavi",
    gray: "Gri",
    green: "Yeşil",
    red: "Kırmızı",
    left: "Sol",
    right: "Sağ",
    allColumns: "Tüm Kolonlar",
    backgroundColorHint: "Kolonun arkaplan rengi",
    textColorHint: "Kolonun metin rengi",
    borderSettings: "Kenarlık Ayarları",
    borderColor: "Kenarlık Rengi",
    borderWidth: "Kenarlık Kalınlığı",
    otherColumns: "Diğer Sütunlar",
    staticStyling: "Sabit Stil",
    liveData: "Canlı Veri",
    otherColumnPlaceholder: "Sütun adı (örn: UrunAdi, Aciklama)",
    otherColumnsHint: "Görsel özelleştirme yapılacak diğer sütunları girin",
    addOtherColumn: "Diğer Sütun Ekle",
    removeOtherColumn: "Diğer Sütunu Sil",
    otherColumnSettings: "Diğer Sütun Ayarları",
    autoDetected: "Otomatik Algılanan",
    backgroundType: "Arkaplan Tipi",
    solid: "Düz",
    gradient: "Geçişli",
    gradientStartColor: "Geçiş Başlangıç Rengi",
    gradientEndColor: "Geçiş Bitiş Rengi",
    gradientDirection: "Geçiş Yönü",
    leftToRight: "Soldan Sağa",
    rightToLeft: "Sağdan Sola",
    topToBottom: "Üstten Alta",
    bottomToTop: "Alttan Üste",
    increaseGradientColors: "Artış Gradient Renkleri",
    decreaseGradientColors: "Azalış Gradient Renkleri",
    diagonal45: "Çapraz (45°)",
    diagonal135: "Çapraz (135°)",
    gradientTextColorHint: "Geçişli arkaplan üzerindeki metin rengi",
    color: "Renk",
    symbol: "Sembol",
    position: "Konum",
    action: "Eylem",
    total: "Toplam",
    filePath: "Dosya Yolu",
    fileName: "Dosya Adı",
    fileUpload: "Dosya Yükle",
    choose: "Seç",
    updateData: "Veriyi Güncelle",
    show: "Göster",
    columns: "Sütunlar",
    changeEvent: "Olayı Değiştir",
    columnSettings: "Sütun Ayarları",
    columnName: "Sütun Adı",
    deleteColumn: "Sütunu Sil",
    cellBackgroundColors: "Hücre Renkleri",
    showCellActionButtons: "Hücre Aksiyon Butonlarını Göster",
    cellBackgroundColor: "Hücre Arkaplan Rengi",
    cell: "Hücre",
    cellPreview: "Hücre Önizleme",
    clear: "Temizle",
    componentBackgroundColor: "Bileşen Arkaplan Rengi",
    columnSqlScripts: "Sütun SQL Komutları",
    imageNameColumn: "Dosya Adı Sütunu",
    columnLanguageSetting: "Sütun Dil Ayarı",
    dataSource: "Veri Kaynağı",
    filter: "Filtre",
    reset: "Sıfırla",
    column: "Sütun",
    image: "Resim",
    searchLocation: "Konum Ara...",
    draggable: "Taşınabilir",
    usersCanChange: "Kullanıcılar Değiştirebilir",
    multiMarker: "Çoklu İşaretçi",
    markerLimit: "İşaretçi Sınırı (0: Sınırsız)",
    meetingType: "Toplantı Türü",
    meetingName: "Toplantı Adı",
    loadingFiles: "Dosyalar Yükleniyor...",
    fileSizeExceeded: "Dosya boyutu aşıldı",
    filesLoaded: "Dosyalar Yüklendi",
    condition: "Koşul",
    value: "Değer",
    connectionAddress: "Bağlantı Adresi",
    imageTypeColumn: "Dosya Türü Sütunu",
    visibleColumn: "Görünür Sütun",
    selectionMode: "Seçim Modu",
    selectMode: "Seçim Modu",
    datagridFiltering: "Veri Tablosu Filtreleme",
    imageDataColumn: "Dosya Sütunu",
    selectDataColumn: "Veri Tablosu Sütunu Seç",
    dataFormat: "Veri Biçimi",
    photoPreview: "Fotoğraf Önizlemesi",
    videoPreview: "Video Önizlemesi",
    displayPhoto: "Fotoğrafı Göster",
    displayVideo: "Videoyu Göster",
    imageColumn: "Resim Sütunu",
    videoColumn: "Video Sütunu",
    columnNameAppear: "Görünmesi Gereken Sütun Adı",
    selected: "Seçilmiş",
    inStock: "Stokta Var",
    messageSave: "Değişikliklerinizi kaydetmek istediğinizden emin misiniz?",
    gallery: "Galeri",
    dollar: "dolar",
    sterling: "sterlin",
    underPhoto: "Fotoğrafın Altında",
    topPhoto: "Fotoğraf Üstü",
    byCategory: "Kategoriye Göre",
    dashboardShowHide: "Göster/Gizle Gösterge Tablosu",
    showDetail: "Detayı Görüntüle",
    hideDetail: "Detayı Gizle",
    decrease: "Azalt",
    increase: "Artır",
    watch: "izle",
    watchMovie: "Film İzle",
    noRecordsFound: "Kayıt Bulunamadı!",
    appearance: "Görünüm",
    numberofColumns: "Sütun Sayısı",
    pagingRecords: "Sayfalama Kayıtları",
    detailLocation: "Detay Konumu",
    hideImages: "Resimleri Gizle",
    quantityCategoryDisable: "Miktar Arttığında Kategoriyi Devre Dışı Bırak",
    // general: "Genel",
    idColumn: "Kimlik Sütunu",
    availableQuantity: "Kullanılabilir Miktar",
    categoryColumn: "Kategori Sütunu",
    photoColumn: "Fotoğraf Sütunu",
    titleColumn: "Başlık Sütunu",
    priceColumn: "Fiyat Sütunu",
    updatablePrice: "Güncellenebilir Fiyat",
    videoGallery: "Video Galerisi",
    uniqueComponent: "Tekil Bileşen",
    showVariant: "Varyantı Göster",
    transferTotalAmount: "Toplam Tutarı Aktar",
    title: "Başlık",
    hide: "Gizle",
    detail: "Detay",
    priceQuery: "Fiyat Sorgusu",
    quantityQuery: "Miktar Sorgusu",
    uniqueComponentError: "Tekil Bileşen Hatası",
    joinColumn: "Birleştirme Sütunu",
    nameColumn: "Ad Sütunu",
    variantScript: "Varyant Betiği",
    variantImages: "Varyant Resimleri",
    variantJoinColumn: "Varyant Birleştirme Sütunu",
    showAll: "Hepsini Göster",
    showSelected: "Seçilenleri Göster",
    showByCategory: "Kategoriye Göre Göster",
    showInStock: "Stoktakileri Göster",
    notYetAdded: "Henüz Eklenmedi",
    added: "Eklendi",
    startingDate: "Başlangıç Tarihi",
    themeFeatures: "Tema Özellikleri",
    menu: "Menü",
    selectMenu: "Menü Seç",
    selectSubmenu: "Alt Menü Seç",
    selectMenuBrowser: "Menü Tarayıcı Seç",
    nameElement: "Ad Elemanı",
    subject: "Konu",
    picture: "Resim",
    pictureElement: "Resim Elemanı",
    startingDateElement: "Başlangıç Tarihi Elemanı",
    endDateElement: "Bitiş Tarihi Elemanı",
    usersCanEdit: "Kullanıcılar Düzenleyebilir",
    thisPropertyCant: "Bu özellik veriler SQL'den alınıyorsa kullanılamaz",
    calendarDisplay: "Takvim Görüntüleme Özellikleri",
    monthly: "Aylık",
    generalDisplayLunarDays: "Ay Günlerinin Genel Görünümü",
    agenda: "Gündem",
    listofWeeklyEvents: "Haftalık Etkinlik Listesi",
    weekly: "Haftalık",
    weekend: "Hafta Sonu",
    generalDisplayWeekDays: "Hafta Günlerinin Genel Görünümü",
    showWeekendDaysWhileWeekdays: "Hafta Günlerini Gösterirken Hafta Sonu Günlerini Göster",
    daily: "Günlük",
    listofDailyEvents: "Günlük Etkinlik Listesi",
    startTime: "Başlama Saati",
    endTime: "Bitiş Saati",
    changeDefaultColor: "Varsayılan Renkleri Değiştir",
    weekdayColor: "Hafta İçi Gün Rengi",
    weekendColor: "Hafta Sonu Gün Rengi",
    eventColor: "Etkinlik Rengi",
    groupBySql: "SQL'ye Göre Grupla",
    groupColumnName: "Grup Sütun Adı",
    assignedColumnName: "Atanan Sütun Adı",
    taskPriortiyColumnName: "Görev Öncelik Sütun Adı",
    taskSubjectColumnName: "Görev Konu Sütun Adı",
    taskDetailColumnName: "Görev Detay Sütun Adı",
    taskQuery: "Görev Sorgusu",
    taskKeyExpression: "Görev Anahtar İfadesi",
    taskTitleExpression: "Görev Başlık İfadesi",
    taskStartDateExpression: "Görev Başlangıç Tarihi İfadesi",
    taskEndDateName: "Görev Bitiş Tarihi Adı",
    taskParentExpression: "Görev Üst İfadesi",
    taskProgressExpression: "Görev İlerleme İfadesi",
    taskColorExpression: "Görev Renk İfadesi",
    taskConnections: "Görev Bağlantıları",
    diagramClear: "Diyagramı temizlemek istediğinize emin misiniz? Bu işlem geri alınamaz.",
    uniqueComponentMenuCloneWarning: "Lütfen benzersiz bileşeni kopyalamadan önce değiştirin.",
    filesLoading: "Dosyalar yükleniyor...",
    couldnotbeLoaded: "yüklenemedi.",
    fileSizeLimit: "Dosya Boyutu Sınırı",
    filesUploaded: "Dosyalar yüklendi",
    filesWillDeleted: "Dosyalar silinecek!",
    filesSureDelete: "Dosyaları silmek istediğinize emin misiniz?",
    fileDelete: "Dosyayı silmek istiyor musunuz?",
    uploadedPhotos: "Yüklenen Fotoğraflar",
    maxSize: "Maksimum Boyut",
    center: "Orta",
    size: "Boyut",
    canItBeUpdated: "Kurulumdan sonra güncellenebilir mi?",
    uploadedFiles: "Yüklenen Dosyalar",
    type: "Tür",
    showdeleteOldData: "Eski Verilerin Silme Seçenekleri",
    videoBrowser: "Tarayıcınız video etiketini desteklemiyor.",
    deleted: "Silinmiş",
    theseComponentElementsDeleted: "Bu bileşen öğeleri silinecek.",
    invalidTarget: "Geçersiz hedef",
    ridge: "Düz Çizgi",
    dotted: "Nokta",
    dashed: "Çizgili",
    addRowColumn: "Satır/Sütun Ekle",
    dataPagingShow: "Verileri Sayfalara Getir",
    borderType: "Kenarlık Türü",
    maxCharacters: "Maksimum Karakter Sayısı",
    edgeThickness: "Kenar Kalınlığı",
    lineSpacing: "Satır Aralığı",
    settingsRow: "Sütun Satır/Sütun Ayarları",
    addRow: "Satır Ekle",
    deleteRow: "Satır Sil",
    rowPermission: "Satır İzinleri",
    addTabs: "Sekme Ekle",
    deletePanel: "Paneli Sil",
    tabPermission: "Sekme İzni",
    addPanel: "Panel Ekle",
    panelPermission: "Panel İzinleri",
    backgroundColor: "Arka Plan Rengi",
    saveAndCloseChildForm: "Yeni bir form açılırken bu alt formu kaydedip kapatılsın mı?",
    saveAndCloseButton: "Kaydedip kapatırken tetiklenecek buton",
    icon: "Sembol",
    selectForm: "Form Seç",
    fontColor: "Yazı Rengi",
    minCharacters: "Minimum Karakter Sayısı",
    generalCategory: "Genel Kategori",
    removeRow: "Kaydı silmek istediğinize emin misiniz?",
    send: "Gönder",
    declineFinish: "Reddet ve Bitir",
    finish: "Bitir",
    noData: "Veri Yok",
    createEditMenu: "Menü Oluştur/Düzenle",
    addNewBreakdown: "Yeni Ayrıntı Ekle",
    addForm: "Form Ekle",
    addBottomBreak: "Alt Ayrıntı Ekle",
    addNode: "Düğüm Ekle",
    topCategory: "Üst Kategori",
    explanation: "Açıklama",
    browserTitle: "Tarayıcı Başlığı",
    formTitle: "Form Başlığı",
    addSqlColumn: "Sql Sütunu Ekle",
    formBg: "Form Arkaplanı",
    codeEditor: "Kod Editörü",
    authorityType: "Yetki Türü",
    viewOnly: "Yalnızca Görüntüle",
    dark: "Koyu",
    white: "Beyaz",
    hightBlack: "Siyah",
    run: "Çalıştır",
    fileLink: "Dosya Linki",
    givePasswordToTheLink: "Linke Şifre Ver",
    giveTheLinkAnExpirationDate: "Link'e son geçerlilik tarihi verin",
    rowColor: "Satır Rengi",
    operator: "Operatör",
    flowOfForm: "Form Akışı",
    columnWidth: "Sütun Genişliği",
    alignLeft: "Sola Hizala",
    alignRight: "Sağa Hizala",
    alignButton: "Düğmeyi Hizala",
    imageTableNameColumn: "Tablo Adı",
    uploadBg: "Arka Plan Yükle",
    selectFile: "Dosya Seç",
    dropFile: "Dosyayı buraya bırak",
    alwaysRoundUp: "Her Zaman Yuvarla Yukarı",
    alwaysRoundBot: "Her Zaman Yuvarla Aşağı",
    default: "Varsayılan",
    deleteOldDataTable: "Tablonun eski verilerini silinsin mi?",
    deleteOldData: "Eski veriler silinsin mi?",
    integer: "Tam Sayı",
    double: "Ondalık Sayı",
    pleaseFillFields: "Lütfen zorunlu alanları doldurun.",
    toastColumnNameNumber: "Sütun adı sayı ile başlayamaz",
    areYouSure: "Emin misiniz?",
    columnDeleted: "Sütun silinecek",
    allColumnDeleted: "Tüm Sütunlar Silinecek",
    idCantStartNumber: "Kimlik sayıyla başlayamaz veya boş olamaz",
    uploadFile: "Dosya Yükle",
    fileViewer: "Dosya Görüntüleyici",
    ok: "Tamam",
    map: "Harita",
    editPanel: "Paneli Düzenle",
    filterColumnName: "Filtre Sütun Adı",
    hintExamples: "ToplamMiktar, örnek:Maas",
    columnLanguageSettings: "Sütun Dil Ayarları",
    fileColumn: "Dosya Sütunu",
    fileNameColumn: "Dosya Adı Sütunu",
    extensionColumn: "Uzantı Sütunu",
    multipleSelection: "Çoklu Seçim",
    addSelectionsRows: "Seçimleri satır olarak ekle",
    mapSettings: "Harita Ayarları",
    formatAndFeatures: "Biçim ve Özellikler",
    enterDateRange: "Tarih aralığı değerini girin",
    filesCanUploadedUsers: "Kullanıcılar dosya yükleyebilir",
    barcodeColumn: "Barkod Sütunu",
    autoAscend: "Otomatik Artış",
    roundType: "Yuvarlama Türü",
    font: "Yazı Tipi",
    columnProcess: "Sütun İşlemi",
    exportColumnTotal: "Toplam sütunu dışa aktar",
    outsideElementDisabled: "Harici Elemanları Devre Dışı Bırak",
    chat: "Sohbet",
    languages: "Diller",
    display: "Resim",
    enterYourComment: "Yorumunuzu girin",
    comment: "Yorumlar",
    fileUploaded: "Dosya yüklendi",
    pdfViewIsButton: "Düğme Olarak Göster",
    takeScreenshot: "Ekran Görüntüsü Al",
    alertText: "Uyarı Metni",
    clearButtonVisible: "Temizle Düğmesini Göster",
    allText: "Tümü",
    letter: "Sadece Harf",
    letterandnumber: "Harf ve Sayı",
    letterandsymbol: "Harf ve Sembol",
    numberandsymbol: "Sayı ve Sembol",
    showIDColumn: "Kimlik Sütununu Göster",
    showCopyButton: "Kopyala Düğmesini Göster",
    showDeleteButton: "Sil Düğmesini Göster",
    showCheckboxButton: "Onay Kutusu Düğmesini Göster",
    autoRowHeight: "Otomatik Satır Yüksekliği",
    exportImport: "Form İçe/Dışa Aktar",
    export: "Dışa Aktar",
    import: "İçe Aktar",
    toastImport: "Form İçe Aktarma Tamamlandı.",
    warningApproveImport: "Gerekli ayarları yaptıktan sonra işlemi onaylayın. Formu içe aktarmak, şu anda açık olan formu kapatır",
    defaultTodaysDateWithTime: "Varsayılan bugünkü tarih ve saat",
    filterVisible: "Sütun Filtresini Göster",
    updatetableMaxQuantity: "Maksimum Güncelleme Miktarı",
    hideQuantity: "Miktar seçimini gizle",
    disableQuantityTextbox: "Miktar yazma kutusunu devre dışı bırak",
    multiplesOfQuantity: "Miktarın katlarını artır/azalt",
    justnumber: "Sadece Sayı",
    paymentHourWarning: "Kontrol saati dışında ödeme yapılamaz.",
    addColumn: "Sütun Ekle",
    mailSettings: "E-posta Seçenekleri",
    newTaskMailDetail: "Yeni bir görev atanırken gönderilecek posta metni",
    updateTaskMailDetail: "Görev düzenlendiğinde gönderilecek posta metni",
    deleteTaskMailDetail: "Görev silindiğinde gönderilecek posta metni",
    completeTaskMailDetail: "Görev tamamlandığında gönderilecek posta metni",
    taskOnDropMail: "Görev taşındığında gönderilecek posta metni",
    selectSMTP: "SMTP Adresi Seç",
    taskCreator: "Görevi Atayan Kişi",
    taskEndDate: "Görev Bitiş Tarihi",
    tags: "Etiketler",
    taskStartDate: "Görev Başlangıç Tarihi",
    taskAssigned: "Görev Atanan Kişi",
    taskDetail: "Görev Ayrıntısı",
    taskSubject: "Görev Başlığı",
    taskPri: "Görev Önceliği",
    taskEdit: "Görev Güncelleme",
    addTask: "Görev Ekle",
    taskStatus: "Görev Durumu",
    excelExportSettings: "Excel Dışa Aktarma Ayarları",
    excelExportRequiredColor: "Zorunlu Alan Sütun Rengi",
    allDataExcelExport: "Veriyi Excel Olarak Dışa Aktar",
    warningApproveImportReport: "Gerekli düzenlemeleri yaptıktan sonra işlemi onaylayın. Raporu içe aktarmak, şu anda açık olan raporu kapatır.",
    reportName: "Rapor Adı",
    emptyReportName: "Lütfen Sağ Taraftan Rapor Adı Ekleyiniz.",
    old: "eski",
    upperNode: "Üst Kırılma",
    pdfViewStaticPdf: "Sabit Dosya Olarak Göster",
    actions: "Eylemler",
    loading: "Yükleniyor",
    exportDataToExcell: "Tüm veriyi Excel'e aktar",
    showRefreshIcon: "Yenileme Düğmesi",
    headerFilter: "Başlık Filtresi",
    filterRowVisible: "Arama Kutusu Sütunda Görünür",
    password: "Parola",
    categories: "Kategoriler",
    pressEnter: "Enter Tuşuna Basın",
    historyColumnValue: "Veri Geçmişi Sütunu",
    hideMobile: "Mobil Cihazlarda Gizle",
    align: "Hizalama",
    theme: "Tema",
    info: "Bilgi",
    showTitle: "Başlığı Göster",
    purple: "Mor",
    brown: "Kahverengi",
    yellow: "Sarı",
    turnOnComments: "Yorumları Aç",
    showContent: "İçeriği Göster",
    canBeHidden: "Gizlenebilir",
    allowEdit: "Düzenleme İzni",
    allowDelete: "Silme İzni",
    allowAdd: "Ekleme İzni",
    allowCopy: "Kopyalama İzni",
    toastDeleteErrorMessage: "Bu bileşen Form Tercih komut dosyalarında kullanılıyor. Silinemez.",
    formOpeningMultiElementEvent: "Çoklu Eleman Oluşturma Olayı",
    resetDatagridLocalSettings: "Datagrid Yerel Ayarlarını Sıfırla",
    loginP1: "River kurumsal hafızanız olarak organizasyon veya kurumunuzun geçmişteki deneyimleri, başarıları, başarısızlıkları, öğrenilen dersler,kültürü ve değerleri gibi bilgileri içeren, gelecekteki kararlar ve eylemler için bir referans kaynağı olarak kullanılabilecek bütünsel bir bellek sistemi sağlar.Kurumsal hafıza, organizasyonun tarihini, iş süreçlerini, çalışanlarının bilgi birikimini,müşteri deneyimlerini, ürün ve hizmetlerinin gelişimini ve daha birçok bilgiyi kapsar.Bu bilgiler, kurumun gelecekteki hedef ve stratejileri için yol gösterici olacaktır.",
    loginP2: "River, web ve gelişmiş native mobil uygulama destekli yapısı ile işletmenizin iş süreçlerini daha verimli ve etkili bir şekilde yürütmesine yardımcı olur. Erişmeniz gereken her şey size bilgisayar, tablet ya da akıllı telefonunuz kadar yakın.",
    loginP3: "Kanban ve gantt grafikleri, bir projeyi veya iş akışını görselleştirmek için son derece kullanışlı araçlardır. İş öğelerinin, mevcut durumlarının ve işin farklı aşamalarındaki iş akışının görsel bir temsilini sağlarlar. Bu, darboğazları belirlemeyi, işleri önceliklendirmeyi ve operasyonel verimliliği artırmayı kolaylaştırır. Kanban ve gantt grafikleri, çevik projelerin yönetimi, yazılım geliştirme ve diğer sürekli iyileştirme süreçleri için pratik ve etkili araçlardır.",
    loginConnect: "Bağlan",
    loginEmailOk: "Onayla",
    loginText: "Giriş",
    loginEmailText: "Email Onay",
    loginMobileText: "Mobil Onay",
    mobileConfirmInfoText: "Mobil Bildirim Gönderildi. Giriş işlemini onaylamak için bildirimi tıklayınız.",
    loginRightMore: "Dahası",
    loginHeaderP1: "Kurumsal Hafızanız",
    loginHeaderP2: "Mobilite",
    loginHeaderP3: "Grafiksel Güç",
    kanbanaddTasks: "Kanban Task Ekleme",
    taskstatusDesciption: "Kanban görevinin atanacağı sütunun isminin görüntülenmesini sağlamaktadır.",
    tasksubjectDescription: "Kanban görevine ait başlık girilmesini sağlamaktadır. Kanban başlığı bir zorunlu alandır.",
    taskassignedToTask: "Göreve Eklenen Gruplar",
    taskassignedTaskDescription: "Kanban görevine atanacak grupların seçilmesini sağlamaktadır.",
    addedForTasks: "Görev İçin Eklenenler",
    taskAssignedInfoDescription: "Görev İçin Bilgilendirilecek Kişiler",
    assignedInfo: "Bilgilendirilecek kişiler",
    groupInfo: "Görev İçin Bilgilendirilecek Gruplar",
    sortEnd: "Bitiş Tarihine Göre Sırala",
    sender: "Gönderen",
    forward: "İlet",
    attachments: "Ekler",
    taskdetailDescription: "Kanban görevine ait detayların girilmesini sağlamaktadır. Kanban detayı bir zorunlu alandır.",
    taskassignedDescription: "Kanban görevine atanacak kullanıcıların seçilmesini sağlamaktadır. Kanbanda en az bir kullanıcı atanması zorunludur.",
    taskstartdateDescription: "Kanban görevinin başlangıç tarihinin seçilmesini sağlamaktadır. Kanbanda başlangıç tarihi otomatik olarak görevin oluşturulma zamanını almaktadır.",
    taskenddateDescription: "Kanban görevinin bitiş tarihinin seçilmesini sağlamaktadır. Kanbanda görev bitiş tarihi otomatik olarak görevin oluşturulma zamanınından bir hafta sonrasını almaktadır.",
    taskpriDescription: "Kanban görevinin öncelik durumunu seçilmesini sağlamaktadır. Kanbanda görev bitiş tarihi otomatik olarak görevin oluşturulma zamanınından bir hafta sonrasını almaktadır.",
    tagsDescription: "Kanban görevine ait etiketlerin eklenmesini sağlamaktadır. Etiketler virgül ile eklendikçe birbirlerinden ayrılmaktadır.",
    outlookDescription: "Outlook a eklensin seçeneği açıkken yapılan görev eklemelerinde outlook hesabınıza giriş yapıp otomatik olarak takvime görev eklenmektedir.",
    taskAssInfoDescription: "Göreve atanmayan ancak bilgisinin olması istenilen kişiler için kullanılan alandır. Bilgilendirmek için eklenen kişiler görevler üzerinde işlem yapamazlar.",
    receiver: "Alıcı",
    draft: "Taslak",
    spam: "Gereksiz E-Posta",
    filterstate: "Duruma Göre Filtrele",
    checkForspelling: "Yazım Hatalarını Kontrol Et",
    emailToForward: "İletilecek E-Posta",
    lowImpMails: "Düşük Önemli Mailler",
    normalImpMails: "Normal Önemli Mailler ",
    highImpEmails: "Yüksek Önemli Mailler",
    showReadMails: "Okunmuş Mailleri Göster",
    groupinfoDescription: "Göreve atanmayan ancak bilgisinin olması istenilen gruplar için kullanılan alandır. Bilgilendirmek için eklenen gruplara ait kişiler görevler üzerinde işlem yapamazlar.",
    timeoutMission: "Görev Bitmeden Uyarıya Başlanacak Saat",
    timeoutmissionDescription: "Kanban görevinin bitiş zamanına yaklaşıldığında uyarıya başlanılacak zamanı belirtmek için kullanılmaktadır",
    taskperiodDescription: "Kanban görevinin bitiş tarihine yaklaşıldığında periyodik olarak hatırlatma süresini belirtmek için kullanılmaktadır.",
    taskProgress: "Görev İlerleme Durumu",
    taskProgressDescription: "Kanban görevine ait ilerleme durumunu belirtmek için kullanılmaktadır. İlerleme durumları Gantt şeması üzerinden görüntülenebilmektedir.",
    updatekanbanTask: "Kanban Task Güncelleme",
    taskcreatorDescription: "Kanban görevi oluşturan kişinin görüntülenmesini sağlamaktadır.",
    uploadfileDescription: "Kanban görevine dosya yüklemek için kullanılmaktadır. Dosya veya resimler DMS üzerine kayıt olmaktadır.",
    infoPersons: "Bilgilendirilecek Kişiler",
    warningtime: "Uyarı Zamanı",
    taskPeriod: "Görev Periyodu",
    taskProgresSatus: "Görev İlerleme Durumu",
    makeTask: "Görevi Oluşturan Kişi",
    addedforTasks: "Görev İçin Eklenenler",
    outlookIntegration: "Outlook Entegrasyonu",
    loginoutlook: "Outlook Takvimine Giriş Yap",
    fetchoutlook: "Outlook Takvimindeki Verileri Getir",
    progressStatus: "İlerleme Durumu",
    taskColors: "Görev Renkleri",
    addcalendarTask: "Takvime Görev Ekleme",
    updatetaskCalendar: "Takvim Task Güncelleme",
    statusComplete: "Tamamlanma Durumu Filtreleme ",
    priorityFilter: "Öncelik Filtreleme",
    columnFilter: "Sütun Filtreleme",
    assignPerson: "Atanan Kişiler",
    assignGroup: "Atanan Gruplar",
    noTask: "Hiçbir Görev Bulunamadı",
    resetSort: "Sıralamayı Sıfırla",
    sortASC: "Sırala A - Z",
    sortDESC: "Sırala Z - A",
    sortAppointment: "Atanma Tarihine Göre Sırala",
    trash: "Çöp Kutusu",
    showOlderMail: "Daha Eski Mailleri Göster",
    mailNotFound: "Mail Bulunamadı",
    sendNewMail: "Yeni Mail Gönder",
    showUnreadMails: "Okunmamış Mailleri Göster ",
    updateColumnMail: "Sütuna Görev Eklendiğinde Kişiye Gidecek Mesaj ",
    addTaskToOutlook: "Görev Outlooka da eklensin ",
    enterYourMessage: "Mesajınızı Giriniz ",
    reminder: "Hatırlatıcı ",
    determinedToTask: "Görev için belirlenen süre ",
    remainingTime: "Kalan süre ",
    hours: "Saat",
    withoutPriority: "Önceliksiz",
    lowPri: "Düşük Öncelikli ",
    normalPri: "Orta Öncelikli",
    highPri: "Yüksek Öncelikli ",
    showAllTasks: "Hepsini Göster ",
    showIncompleteTasks: "Tamamlanmamışları Göster",
    showCompeletedTasks: "Tamamlananları Göster ",
    reportDesigner: "Rapor Tasarımcısı ",
    fileManagementSystem: " Dosya Yönetim Sistemi ",
    formDesigner: "Form Tasarımcısı ",
    boardDesigner: " Pano Tasarımcısı",
    themeSettings: "Tema Özellikleri",
    social: "Sosyal",
    profile: " Profil",
    contacts: " Kişiler",
    files: " Dosyalar",
    pages: "Sayfalar",
    noResultsFound: " Sonuç Bulunamadı",
    processes: "Süreçler",
    filterByStatus: "Duruma Göre Filtrele ",
    filterByPri: "Önceliğe Göre Filtrele",
    filterByCol: "Sütuna Göre Filtrele",
    todoAddTasks: "To-Do Task Ekleme",
    addLabel: "Etiket Giriniz",
    showWithSubTasks: "Alt Görevi Olanları Göster",
    riverBoard: "River Panolar",
    notify: "Bildirimler",
    likedYourPost: "Gönderinizi Beğendi ",
    likedYourComment: "Yorumunuzu Beğendi ",
    systemNotify: "Sistem Bildirimleri ",
    readAllNotify: "Tum Bildirimleri Oku ",
    recommendedUsers: "Önerilen Kişiler",
    suggestedPosts: "Önerilen Gönderiler",
    sPostReposted: "Gönderisi Yeniden Paylaşıldı",
    shareSomething: "Birşeyler Paylaş",
    updatePost: "Gönderiyi Güncelle",
    ifYouDoNotSelectGroup: "Grup seçmezseniz gönderinizi herkes görebilir",
    addComment: "Yorum Ekle",
    sendComment: "Yorum Gönder",
    areYouSureYouWantToDeleteThisPost: "Gönderiyi Silmek İstediğinizden Emin misiniz",
    yes: "Evet",
    no: "Hayır",
    deletePost: "Gönderiyi Sil",
    postSuccesfullyDeleted: "Gönderi başarıyla silindi",
    deleteComment: "Yorum Sil",
    areYouSureYouWantToDeleteThisComment: "Bu yorumu silmek istediğinizden emin misiniz",
    commentSuccesfullyDeleted: "Yorum Başarıyla Silindi",
    sharePost: "Gönderi Paylaş",
    areYouSureYouWantToShareThisPost: "Bu gönderiyi paylaşmak istediğinizden emin misiniz",
    repostedSuccessfully: "Başarıyla Yeniden Paylaşıldı",
    upload: "Yükle",
    refresh: "Yenile",
    allowedExtentions: "İzin verilen uzantılar: JPG, GIF veya PNG. Maksimum dosya boyutu",
    systemLandingPagePreference: "	Açılış sayfası Tercihi",
    allownonadminuserstosearchforotherusers: "Admin olmayan kullanıcılar diğer kullanıcıları arayabilsin",
    passwordChange: "Şifre Değişikliği",
    newPassword: "Yeni Şifre",
    retypethenewpassword: "Yeni şifreyi tekrar yazınız",
    notifications: "Bildirimler",
    showWhoLikesYourPost: "Postlarınızı beğenenleri göster",
    showWhoLikesYourComment: "Yorumlarınızı beğenenleri göster",
    aboutMe: "Hakkımda",
    bio: "Biyografi",
    dateOfBirth: "Doğum Tarihi",
    website: "Web sitesi",
    phone: "Telefon",
    saveChanges: "Değişiklikleri Kaydet",
    username: "Kullanıcı adı",
    content: "İçerik",
    projectManagement: "Proje Yönetimi",
    addPage: "Sayfa Ekle",
    addFolder: "Klasör Ekle ",
    showUsers: "Görebilecek Kullanıcılar ",
    showGroups: "Görebilecek Gruplar",
    readonlyUsers: "Salt Okunur (Kullanıcılar)",
    readonlyGroups: "Salt Okunur (Gruplar)",
    columnHeight: "Sütun Yüksekliği",
    showKanbanCount: "Kanban Adet Bilgisini Göster",
    kanbanSettings: "Kanban Ayarları ",
    gantSettings: "Gant Ayarları ",
    schedulerSettings: "Takvim Ayarları ",
    showRowLines: "Satır Çizgilerini göster ",
    activateOutlookConnection: "Outlook Bağlantısını Etkinleştir ",
    selectOutlookColumn: "Outlook sütununu seçiniz ",
    selectSMTPPopoverText: "Kanban, Gantt, Takvim veya To-Do bileşenlerinde kullanılacak mail SMTP seçimi yapılmaktadır. ",
    menuFilePathId: "River Menu klasörü id",
    recycleBinPathName: "River Çöp Kutusu Klasörü Adı",
    recycleBinPathId: "River Çop Kutusu Klasörü Id",
    fileNameChangedMessage: "Dosya ismi başarıyla değiştirildi.",
    fileNameChangedErrorMessage: "Dosya ismi değiştirilemedi.",
    fileCreatedMessage: "Dosya başarıyla oluşturuldu.",
    newTaskMailDetailPopoverText: "Kanban, Gantt, Takvim veya To-Do bileşenlerine yeni bir görev atandığında, atanan kullanıcılara gönderilecek olan otomatik mail içerisine eklenecek mail içeriğinin eklendiği kısım. ",
    taskOnDropMailPopoverText: "Kanban, Gantt, Takvim veya To-Do bileşenlerine bir görevin bulunduğu sütununun değiştirilmesiyle birlikte gönderilecek olan otomatik mail içerisine eklenecek mail içeriğinin eklendiği kısım. ",
    createdBy: "Oluşturan",
    updatedBy: "Güncelleyen",
    createdDate: "Oluşturulma Tarihi",
    updatedDate: "Güncellenme Tarihi",
    folderPermissionSettings: "Dosyası yetki ayarları",
    quantity: "Adet",
    fileManagementPermissionSettings: "Dosya Yönetimi Yetki Ayarları",
    fileNotFoundErrorText: "Aradığınız kriterlere uygun dosya bulunamadı.",
    fileSearchInfoText: "Arama işlemi devam ediyor",
    updateTaskMailDetailPopoverText: "Kanban, Gantt, Takvim veya To-Do bileşenlerine ilgili görevde değişiklik yapıldığında, atanan kullanıcılara gönderilecek olan otomatik mail içerisine eklenecek mail içeriğinin eklendiği kısım. ",
    deleteTaskMailDetailPopoverText: "Kanban, Gantt, Takvim veya To-Do bileşenlerine ilgili görev silindiğinde, atanan kullanıcılara gönderilecek olan otomatik mail içerisine eklenecek mail içeriğinin eklendiği kısım. ",
    completeTaskMailDetailPopoverText: "Kanban, Gantt, Takvim veya To-Do bileşenlerine ilgili görev tamamlandığında, atanan kullanıcılara gönderilecek olan otomatik mail içerisine eklenecek mail içeriğinin eklendiği kısım. ",
    selectOutlookColumnPopoverText: "Outlook üzerinden eklenecek olan görevlerin hangi sütuna dahil edileceği seçilmektedir. ",
    createFolder: "Dosya Oluştur",
    versionHistory: "Sürüm Geçmişi",
    subFileManager: "Alt Dosya Yöneticisi",
    removeSubFiles: "Alt Dosyayı Kaldır",
    parentFolder: "Üst Klasör",
    deletePermanently: "Kalıcı Olarak sil",
    recover: "Kurtar",
    groupPermissions: "Grup Yetkileri",
    allowUpload: "Dosya Yükleme İzni",
    allowView: "Dosya Görüntüleme İzni",
    allowDownload: "Dosya indirme İzni",
    permissionType: "İzin Tipi",
    applyToSubFolders: "Tüm alt klasörlere uygula",
    newFolderName: "Yeni Dosya Adı",
    tagTips: "Etiketlemeler başında # işareti ile yapılmalıdır. İçerisinde sadece sayı ve harf bulunabilir",
    addAsNewVersion: "Yeni bir sürüm olarak yükle",
    addAndChangeName: "İsmini değiştirerek yükle",
    skip: "Atla",
    fileExistError: "Hedef klasörde aynı isimde dosya mevcut",
    processFileShow: "River Süreç Klasörünü göster",
    processFilePathName: "River Süreç Klasörü ismi",
    processFilePathId: "River Süreç klasörü id",
    menuFileShow: "River Menü Klasörünü göster",
    menuFilePathName: "River Menu Klasörü ismi",
    fileCreatedErrorMessage: "Dosya oluşturma işlemi başarısız.",
    fileDeletedessage: "Dosya silme işlemi tamamlandı.",
    fileDeletedErrorMessage: "Dosya silme işlemi başarısız.",
    fileMovedMessage: "Dosya taşıma işlemi tamamlandı.",
    fileMovedErrorMessage: "Dosya taşıma işlemi başarısız.",
    fileCopyMessage: "Dosya kopyalama işlemi tamamlandı.",
    fileCopyErrorMessage: "Dosya kopyalama işlemi başarısız.",
    fileDownloadMessage: "Dosya indirme işlemi tamamlandı.",
    fileDownloadErrorMessage: "Dosya indirme işlemi başarısız.",
    fileSizeShowErrorMessage: "Dosya boyutu büyük olduğu için görüntüleyemiyoruz. Lütfen dosyayı indirin",
    unsupportedFile: "Desteklenmeyen dosya",
    fileNameError: "Bu dosya adında bir dosya mevcut farklı bir ad ile tekrar deneyiniz",
    fileGivePermissionMessage: "Dosya yetkilendirmesi başarıyla tamamlandı.",
    fileGivePermissionErrorMessage: "Dosya yetkilendirmesinde hata oluştu. Kayıt başarısız.",
    groupName: "Grup Adı",
    createGroup: "Grup Oluştur",
    conversation: "Konuşmalar",
    startConversation: "Konuşma Başlat",
    userNotFound: "Kişi bulunamadı",
    chatNotFound: "Sohbet bulunamadı",
    themeTypeLight: "Aydınlık",
    themeTypeBorderedLight: "Çerçeveli",
    themeHalfDark: "Yarı Koyu",
    themeDark: "Koyu",
    themeRouteAnimation: "Geçiş Animasyonu",
    themeRouteAnimationFadeInLeft: "Soldan Solma",
    themeRouteAnimationZoomIn: "Yakınlaştır",
    themeRouteAnimationFadeIn: "Solma",
    themeRouteAnimationNone: "Yok",
    themeMenuType: "Menü Tipi",
    themeMenuTypeHorizontal: "Yatay",
    themeMenuTypeVertical: "Dikey",
    themeMenuCollapse: "Dar Menü",
    themeMenuHidden: "Gizli Menü",
    themeNavbarColor: "Gezinme Çubuğu Rengi",
    themeNavbarType: "Gezinme Çubuğu Türü",
    themeSticky: "Yapışkan",
    themeStatic: "Statik",
    themeFloating: "Yüzer",
    themeHidden: "Gizli",
    themeFooterType: "Alt Bilgi Türü",
    catalog: "Katalog",
    riverBoards: "River Panolar",
    clipboardDesigner: "Pano Tasarımcısı",
    desingMode: "Tasarım Modundasınız",
    editPage: "Sayfayı Düzenle",
    rename: "Yeniden Adlandır",
    exportToPdf: "PDF olarak Çıktı Al",
    exportToExcel: "Excel Olarak Çıktı Al",
    revenueReport: "Gelir Raporu",
    header: "Başlık",
    connection: "Bağlantı",
    primaryKey: "Birincil anahtar",
    secondaryKey: "İkincil Anahtar",
    completedKey: "Tamamlanan Anahtar",
    countKey: "Sayım Anahtarı",
    statusKey: "Durum Anahtarı",
    progressConnection: "İlerleme Bağlantısı",
    progressScript: "İlerleme Scripti",
    progressPrimaryKey: "İlerleme Birincil Anahtarı",
    progressCountKey: "İlerleme Sayısı Anahtarı",
    progressPercentageKey: "İlerleme Yüzdesi Anahtarı",
    progressColorKey: "İlerleme Renk Anahtarı",
    keyColumn: "	Değer Sütunu",
    currency: "Para Birimi",
    whitePage: "Beyaz Sayfa",
    noReportSelected: "Rapor Seçilmedi",
    noTypeSelected: "Rapor Tipi Seçilmedi",
    whitePageReports: "Beyaz Sayfa Raporu",
    addBranch: "Kırılım/Alt Kırılım Ekle",
    branchName: "	Kırılım Adı",
    rowNumber: "Sıra Numarası",
    reportTypeSelect: "Rapor Tipi Seçiniz",
    reportDescription: "Rapor açıklaması...",
    useWeb: "Web'de Kullanılsın",
    useMobile: "Mobil'de Kullanılsın",
    mainScript: "Ana Script",
    prerunScript: "Ön script çalıştır?",
    preScript: "Ön Script",
    testIt: "Test Et",
    selectAll: "Tümünü Seç",
    addReport: "Rapor Ekle",
    selectReportType: "Rapor Tipi Seçiniz",
    reportType: "Rapor Tipi",
    reportDesingPermission: "Kullanıcının rapor tasarım izni bulunmamaktadır.",
    reportImportedOpenLeftMenu: "Rapor İçeri Aktarıldı. Sol Menüden Açabilirsiniz.",
    forReportExport: "Rapor Export için önce rapor seçmelisiniz.",
    reportDeleted: "Rapor Silindi",
    branchDeleted: "Kırılım Silindi",
    addBranchName: "Lütfen kırılım adını giriniz",
    addedBranch: "Kırılım Eklendi",
    selectConnectionAddress: "	Lütfen bağlantı adresi seçiniz",
    enterSqlScript: "Lütfen sql script giriniz",
    enterReportName: "Lütfen rapor adını giriniz",
    reportAdded: "Rapor Eklendi",
    numberOfDataToBeProcessed: "Bağlantı başarılı. İşlenecek veri sayısı:",
    dataNotFoundCheckYourConnection: "Veri bulunamadı! Lütfen bağlantınızı ve sql komutunuzu kontrol ediniz",
    connectionNotFoundCheckYourConnection: "Bağlantı sağlanamadı! Lütfen bağlantınızı ve sql komutunuzu kontrol ediniz",
    fillConnectionAndSql: "Lütfen bağlantınızı ve sql komutunuzu doldurunuz",
    allTypesActivate: "Görüntüleme Anında Bütün Tipler Aktif Olsun",
    passwordRequired: "Şifre gereklidir",
    showLess: "Daha Az Göster",
    showMore: "Daha Fazla Göster",
    authority: "Yetki",
    preScriptDescription: "Ön script açıklaması",
    enterReportFilters: "Rapor Filtrelerini Giriniz",
    gridDesigner: "Grid Tasarımcı",
    addMainBranch: "Ana Kırılım Ekle",
    resetSettings: "Ayarları Sıfırla",
    columsToGroup: "Verileri gruplandırmak için başlık sütunlarının içerik menüsünü kullanın",
    customize: "Özelleştirme",
    colorType: "Renk Tipi",
    formatManagement: "Format Yönetimi",
    bottomTotalColumn: "Dip Toplam Kolonu",
    formatType: "Format Tipi",
    datagridSettingsReset: "Data grid ayarları sıfırlanacak",
    unexpectedError: "Üzgünüz, beklenmedik bir hata ile karşılaştık.",
    changesSaved: "Değişiklikler kaydedildi",
    addGantTask: "Gant Görevi Ekle",
    updGantTask: "Gant Görevi Güncelle",
    updSchedulerTask: "Takvim Görevi Güncelle",
    updTodoTask: "To-Do Görevi Güncelle",
    completeTask: "Görevi Tamamla",
    cantBeEmptyKanban: "Görev başlığı, görev detayı ve görev atanan kişi boş olamaz",
    successAdd: "Görev başarıyla eklendi",
    successUpd: "Görev başarıyla güncellendi",
    errorReadonlyUpd: "Yetkiniz olmadığı için görevi güncelleyemezsiniz.",
    errorCompletedUpd: "Tamamlanmış görevi güncelleyemezsiniz.",
    statusChangeTodo: "Görevin Tamamlanma Durumu Başarıyla Değiştirildi.",
    reminderSended: "Görev için başarıyla hatırlatma maili gönderildi",
    askForCompleteTask: "Görevi Tamamlamak İstediğinize Emin Misiniz?",
    infoForCompletedTask: "Görevinize ait alt görevler de tamamlanacaktır.",
    noPermisison: "Yetkiniz Bulunmamaktadır.",
    successDependencyAdded: "Görev Bağımlılığı Başarıyla Eklendi",
    filterimportant: "Önemine Göre Filtrele",
    enterEmail: "E-posta adresi giriniz",
    reply: "Cevapla",
    newCol: "Yeni Sütun",
    thickness: "Kalınlık",
    distanceToUpperComponent: "Üstteki komponentle arasındaki mesafe",

    showEmailModule: "E-Posta modülünü göster",
    distanceToBottomComponent: "Alttaki komponentle  arasındaki mesafe",
    canNonAdminUsersPost: "Admin olmayan kullanıcılar post atabilsin mi",
    columnColor: "Sütun Rengi",
    byWho: "Tarafından",
    updated: "Güncellendi",
    commentAdded: "Yorum Eklendi",
    completed: "Tamamlandı",
    addRemoveColumns: "Sütun Ekle-Çıkar",
    searchMessage: "Mesajlarda ara",
    riverReports: "River BI Raporlar",
    forms: "Formlar",
    searchinProcess: "Süreçlerde Ara",
    searchVoiceMessage: "Aradığınız mesaj bu ses dosyasının içinde geçmektedir",
    searchVoiceMessages: "Sesli mesajlarda arama",
    showSocialNotifications: "Sosyal Bildirimlerini Göster",
    showProjectManagementNotifications: "Proje Yönetimi Bildirimlerini Göster",
    showProcessNotifications: "Süreç Bildirimlerini Göster",
    pageDesingPermission: "Kullanıcının sayfa tasarım izni bulunmamaktadır.",
    filemanagementDesingPermission: "Kullanıcının dosya yönetim izni bulunmamaktadır.",
    taskDelete: "Görev Silinecek.",
    tasksWillDeleted: "Görevi Silmek İstediğinize Emin Misiniz?.",
    componentSettings: "Bileşen Ayarları",
    aboutComponent: "Bileşen Hakkında",
    sureSaveChanges: "Yaptığınız değişikleri kaydetmek istediğinizden emin misiniz?",
    showDeletedNotifications: "Sildiğim Bildirimleri Göster",
    shareSometthing: "Bir Şeyler Paylaş",
    resetPageLayout: "Sayfa Tasarımını Sıfırla",
    downloadingSS: "Ekran görüntüsü indiriliyor.Lütfen Bekleyiniz.",
    showHorizontalLines: "Yatay Çizgiler Görünsün",
    turnOffVerticalHide: "Dikey Gizleme Kapansın",
    whichVerticalLinesAreToBeHidden: "Hangi dikey çizgi - çizgiler görünmesin",
    priority: "Öncelik",
    boardSidebarMessageField: "Görev Mesaj Alanı",
    boardSidebarExtraField: "Görev Ekstra Bileşen Alanı",
    boardSidebarTaskHistory: "Hareket Geçmişi",
    loadMoreNotifications: "Daha Fazla Bildirim Göster",
    deletedNotifications: "Silinen Bildirimler",
    noFormNotification: "Henüz Süreç Bildirimi Bulunmuyor",
    noDeletedFormNotifications: "Silinen süreç bildirimi bulunmuyor",
    noDeletedBoardNotification: " Silinen Pano Bildirimi Bulunmuyor",
    noBoardNotification: " Henüz Pano Bildirimi Bulunmuyor",
    noDeletedSocialNotification: "Silinen Sosyal Medya Bildirimi Bulunmuyor",
    noSocialNotification: "Henüz Sosyal Medya Bildirimi Bulunmuyor",
    deleteAll: "Tümünü Sil",
    markAllRead: "Tümünü Okundu İşaretle",
    board: "Pano",
    form: "Form",
    formNotifications: "Form Bildirimleri",
    boardNotifications: "Pano Bildirimleri",
    socialNotifications: "Sosyal Bildirimleri",
    email: "E-posta",
    oldFormName: "Eski Form Adı",
    newFormName: "Yeni Form Adı",
    oldFormVariable: "Eski Form Değişkeni",
    newFormVariable: "Yeni Form Değişkeni",
    oldCategory: "Eski Kategori",
    newCategory: "Yeni Kategori",
    connectionInFile: "Dosyadaki Bağlantı",
    yourConnection: "Sizin Bağlantınız",
    element: "Element",
    script: "Script",
    formClosingEvent: "Form Kapanma Etkinliği",
    message: "Mesaj",
    formExportTextError: "Forma eklenen komponent yok ya da form kaydedilmemiş. İşlemin hatalı çalışmaması için lütfen bu sorunu düzeltiniz.",
    checkRequiedFields: "Zorunlu Alan Kontrolü Yapılsın",
    dontCheckRequiredFields: "Zorunlu Alan Kontrolü Yapılmasın",
    createPdfWarning: "Bu işaretlendiğinde, form kaydedilmez ve kapatılmaz",
    cratePdf: "PDF Oluştur",
    identityNumber: "TC Kimlik No",
    minPaymentHour: "Minimum Saat",
    maxPaymentHour: "Maksimum Saat",
    darkBlue: "Koyu Mavi",
    orange: "Turuncu",
    component: "Bileşen",
    properties: "Özellikler",
    dmsPath: "DMS Yolu",
    dashboard: "Dashboard",
    slider: "Slider",
    list: "Liste",
    otherImages: "Diğer Resimler",
    unitScript: "Birim Script",
    updatableMaxQuantity: "Güncellenebilir Maks. Miktar",
    newPage: "Yeni Sayfa",
    code: "Kod",
    resetHiddenComponent: "Gizlenen hedef komponentlerin değeri sıfırlansın",
    refreshedValueWillBeDefault: "Yenilendiğinde ilk değer varsayılan olsun",
    bold: "Kalın",
    italic: "İtalik",
    stringFormat: "String Format",
    videoUploaded: "Video Yüklendi",
    fillInAllFields: "Tüm Alanları Doldurun",
    normalPaging: "Normal Sayfalama",
    pageSize: "Sayfa Boyutu",
    special: "Özel",
    link: "Bağlantı",
    fontWeight: "Yazı Kalınlığı",
    fontFamily: "Yazı Tipi",
    pdfFileNotFound: "PDF Dosyası Bulunamadı",
    likedOn: "tarihinde beğendi",
    subCategory: "Alt Kategori",
    toTheBoard: "Panosuna",
    changeTasksPage: "Görevin Panosunu Değiştir",
    hideTaskDetail: "Görev Detayını Gizle",
    selectData: "Veri Seç",
    noContentYet: "Henüz İçerik Bulunmamaktadır.",
    addRowBetween: "Araya Satır Ekle",
    userPermissions: "Kullanıcı Yetkileri",
    askForPassword: "Şifre Sorulsun Mu?",
    passwordIsWrong: "Şifre hatalı, lütfen tekrar deneyin.",
    pleaseEnterPassword: "Lütfen devam etmek için kullanıcı şifrenizi giriniz.",
    onePaymentEachSave: "Her Kayıt İçin Tek Ödeme",
    riverModules: "RIVER Modülleri",
    processHistory: "Süreç Geçmişi",
    commentHasBeenMadeAtThisStage: "Yorum bu aşamada eklendi",
    clearSelection: "Seçimi Temizle",
    allowDownloadVersionHistoryDocuments: "Sürüm Geçmişi İndirme İzni",
    addNewColor: "Yeni Kolon Ekle",
    delegated: "Devredildi",
    openDocxToPdf: "PDF Olarak Dosyayı Aç",
    activationStartDate: "Aktivasyon Başlangıç Tarihi",
    activationEndDate: "Aktivasyon Bitiş Tarihi",
    changeActivationDate: "Aktivasyon Tarihini Değiştir",
    showArchive: "Arşivi Göster",
    hideArchive: "Arşivi Gizle",
    tasks: "Görevler",
    maxFileCountLimit: "Maksimum Dosya Adedi",
    fileCountLimit: "Dosya Sayısı Sınırı",
    numberOfFilesExceeded: "Dosya sayısı aşıldı",
    numberOfFilesLimit: "Dosya sayısı Sınırı",
    lineIntermediateAllowAdd: "Araya satır ekle",
    lineIntermediateAllowCopy: "Araya satır kopyala",
    triggerReport: "Rapora Parametre Gönder",
    setWhitePageReportExportName: "Beyaz Sayfa Raporunun Dışarı Aktarma İsmini Belirle",
    menuRowUpdated: "Bu otomatik artan verisiyle kayıtlı veri bulunmaktadır. Otomatik artan numarası güncellendi: ",
    isMenuRowControl: "Otomatik artan kontrolü",
    sqlScriptWarning: "Bu alanı kullanmak performans kayıplarına sebep olabilir.",
    deletedTask: "Silinmiş Görev",
    getDeletedTasks: "Silinmiş Görevleri Getir",
    getTasks: "Görevleri Getir",
    movePageDesignersNode: "Seçili Pano/Menü Klasöre Taşınacaktır",
    informationAboutMoveToDirectory: "Taşınan Pano/Menü'nün kullanıcı yetkileri, içine aktarılan klasörün yetkisine göre değişecektir. ",
    move: "Taşı",
    download: "İndir",
    create: "Oluştur",
    statistic: "İstatistik",
    priRate: "Öncelik Sırasına Göre Atama Oranı",
    taskcreatorlist: "Görev Oluşturanların Listesi",
    completionRate: "Tamamlanma Oranı",
    columnsTaskCount: "Sütunlardaki Görev Sayısı",
    showKanbanFilter: "Kanban Filtrelerini Göster",
    showFileHistory: "Dosya Geçmişini Göster",
    processToStart: "Başlatılacak Süreç",
    fieldMatching: "Alan Eşleştirme",
    dontLetDeleteWhatTheyAdded: "Kendi eklediğini silebilsin",
    myJobs: "İşlerim",
    excelExportName: "Excel dışarı aktarma adı",
    filterSearch: "Görevlerde Arama",
    filterForAssignUsers: "Kişiye Göre Filtreleme",
    filterForAssignUGroups: "Gruba Göre Filtreleme",
    filterForPri: "Öncelik Durumuna Göre Filtreleme",
    clearFilter: "Filtreleri Temizle",
    makeReadOnly: "Salt Okunur Yap",
    letItWorkProcessContinues: "Süreç Devam Ettiğinde Çalışsın",
    event: "Etkinlik",
    selectEvent: "Etkinliği Seç",
    rowEditor: "Satır Düzenleme",
    formOpeningComponentEvent: "Form Açılışı Bileşen Etkinliği",
    addedTask: "eklendi",
    updatedTask: "güncellendi",
    messageAddedToTask: "mesaj eklendi",
    deleteTask: "silindi",
    completedTask: "tamamlandı",
    boardToastNotification: "{{0}} tarafından {{1}} panosunda {{2}} adlı görev {{3}}",
    socialToastNotification: "{{0}}, gönderinizi  beğendi",
    repostToastNotification: "{{0}}, gönderinizi  tekrar paylaştı",
    isReposted: "gönderinizi tekrar paylaştı.",
    processToastNotification: "{{0}} tarafından {{1}} adlı forma yorum yapıldı",
    yesterday: "Dün",
    today: "Bugün",
    notSaved: "Kaydedilmedi",
    editors: "Editorler",
    basic: "Temel",
    file: "Dosya",
    datagridPreferences: "Datagrid Tercihler",
    deleteLetsAsk: "'Silinsin mi?' sorulsun.",
    addNewRow: "Sorulmasın, Yeni satır olarak eklesin.",
    oldRowShouldBeDeleted: "Sorulmasın, Eski satırlar silinsin.",
    canBeSearched: "Arama yapılabilsin mi?",
    processName: "Süreç Adı",
    removeReadOnly: "Salt Okunur Özelliği Kaldır",
    dontMakeRequired: "Zorunlu Alanı Kaldır",
    generalSettings: "Genel Ayarlar",
    pageDesignerFirstPage: "İlk Sayfa",
    beginDayHour: "Gün Başlangıç Saati",
    endDayHour: "Gün Bitiş Saati",
    dayTimeDuration: "Gün Zaman Aralığı",
    colorSettings: "Renk Ayarları",
    colorSettingsDescription: "Veri arkaplan rengi.",
    dataName: "Veri Adı",
    margin: "Kenar Boşluğu",
    rowCount: "Satır Sayısı",
    colCount: "Sütun Sayısı",
    outsideMargin: "Dış Kenar Boşluğu",
    widgetName: "Bileşen  Adı",
    searchInProcess: "Süreç Formları",
    changeEventScriptRun: "İçeri veri doldurulduğunda change scriptler tetiklensin mi?",
    dontChanceId: "(Bu bileşen form etkinliğinde kullanıldığı için nesne kimliği değiştirilemez.)",
    scriptButtonWarning: "Script butonu durum ayarları Menü formlarında desteklenmemektedir.",
    infiniteScroll: "Sonsuz Kaydırma",
    scrollSettings: "Kaydırma Ayarları",
    pageNameSetting: "Sayfa Adı Ayarları",
    showPageName: "Sayfa Adını Göster",
    bindProcess: "Süreci Sayfaya Bağlama",
    bindProcessDetail: "Süreç sayfaya bağlandığında sayfa salt okunur bir biçimde mevcut olacaktır. Sayfadaki değişiklikler sadece süreç üzerinden düzenlenebilir. Sayfa verisi düzenlenirken süreç formu açılır.",
    description2: "Açıklama 2",
    showJobListTabs: "İş listesi sekmelerini göster",
    showUserPhotosInJobList: "İş listesinde kullanıcıların fotoğraflarını göster",
    dmsVideoGaleryTabWarning: "Bu alanı kullanma yetkiniz bulunmamaktadır.",
    searchInFormJson: "Form json içinde arama yapılsın",
    useExpandedJoblist: "Büyütülmüş İş Listesi Kullan",
    editTour: "Turu düzenle",
    saveAllForm: "Bütün Formları Güncelle",
    selectComponent: "Bileşeni Seç",
    tourComponents: "Tur Bileşenleri",
    addTourElement: "Tur Elemanı Ekle",
    startTourWhenFormOpen: "Form Açıkken Turu Başlat",
    compare: "Karşılaştır",
    tourWillDeleted: "Tur silinecek",
    deleteTourElement: "Tur Elemanını Sil",
    tourDelete: "Turu sil",
    fixedRowHeight: "Sabit Satır Yüksekliği",
    pushWidgetItems: "Widget Öğelerini Kaydır",
    allowMultiLayer: "Çok Katmanlı İzni Ver",
    gridType: "Grid Türü",
    useCollapsedJoblist: "Daraltılmış İş Listesi Kullan",
    searchAllData: "Tüm verilerde arama yapılsın",
    scriptsRunAllAreSelected: "Hepsi seçildiğinde scriptler çalışsın mı?",
    menuSchedulerPermission: "Menü kartı ekleme yetkiniz bulunmamaktadır",
    menuSchedulerFormPermission: "Takvimden Form Ekleme/Düzenleme işlemi yapılamamaktadır",
    showOnTask: "Editör süreçlerde gözüksün mü",
    showAsPopupOnTrigger: "Formda gizli, veri tetiklenince popup'ta göster",
    alreadyHaveMenu: "Menü bileşeni kullanmak istiyorsanız formda sadece menü bileşeni olmalıdır ve birden fazla menü bileşeni eklenemez.",
    select: "Seç",
    startedUserName: "Başlatan Adı",
    startedUserId: "Başlatan ID",
    processInstanceId: "Süreç Numarası",
    formId: "Form ID",
    min: "Minimum",
    difference: "İki Dosya Arasındaki Değişiklikler",
    labelNotFound: "Etiket bu dilde tanımlanmamış",
    cleanElement: "Veri yazdırırken element alanını temizle?",
    cleanColumn: "Veri yazdırırken sütun alanı temizlensin mi?",
    fileSkippedSuccessfully: "İptal edildi.",
    dmsTags: "Etiket",
    searchInFormContents: "Form içeriklerinde ara",
    jobType: "İş Tipi",
    workStatus: "İş Durumu",
    sendMailManager: "Seçilen kullanıcıların yöneticilerine mail gönder",
    or: "Ya da",
    signInWithMicrosoft: "Microsoft Hesabıyla Giriş",
    receipt: "Fiş",
    receiptOptions: "Makbuz seçenekleri",
    tax: "KDV",
    selectboxWarningMessage: "Veri 100'den fazla olduğu için lütfen lookup bileşenini kullanınız. İlk 100 değer gösterilmekte.",
    degree: "Derece",
    completeDateShort: "Tam.Ta:",
    confirmationPopupClose: "Eğer bir işlem yapmazsanız, onay popupı otomatik olarak kapanacaktır.",
    confirmationSecondsSetting: "Onay penceresi saniye ayarı",
    createPdfAndSendForm: "Pdf oluştuğunda form gönderilsin mi?",
    confirmCreatePdfAndSendForm: "Pdf oluşturulacak ve form gönderilecek. Onaylıyor musunuz?",
    onlyNumbersError: "Sadece sayı içeren bir değer girmelisiniz",
    _filter: "Filtrele",
    removeFromFavorites: "Favorilerden kaldır",
    addToFavorites: "Favorilere Ekle",
    id: "ID",
    assignedUserName: "Atanan kişi/Grup",
    schemeId: " Süreç ID",
    formStatusByUser: "Açıklama",
    formSituationByUser: "Açıklama 2",
    isDelegated: "Form delege edilmiş mi?",
    formname: "Form ismi",
    formstatus: "Form durumu",
    timeOutDate: "Zaman aşımı tarihi",
    saveFilterPack: "Filtre paketi kaydet",
    enterRegistrationName: "Kayıt ismini giriniz",
    filterPackages: "Filtre paketleri",
    speechLengthError: "Konuşma istenilen değerden daha uzun",
    removeImage: "Kaldır",
    headerBundle: "Başlık Gruplama Öğesi",
    other: "Diğer",
    verticalHeader: "Dikey Başlık",
    exportDataAuth: "Dışarı Aktarma Yetkilendirmeleri",
    errorFileType: "Dosya tipi hatalı. Kabul edilen dosya tipi: ",
    folder: "Klasör",
    page: "Sayfa",
    uploadPdfToDms: "Dms'e oluşturulan Pdf'i yükleme",
    uploadPdfToDmsName: "Dms'e kaydedilecek Pdf'in ismini giriniz.",
    pdfName: "Pdf İsmi",
    addTour: "Tur Ekle",
    updateTour: "Turu Güncelle",
    editTourElement: "Tur Elemanını Düzenle",
    buttonAction: "Buton Olayı",
    referenceArea: "Referans Alanı",
    fieldToFill: "Doldurulacak alan",
    buttonColor: "Buton rengi",
    signFile: "Dosyayı İmzala",
    eSignFile: "Dijital E-İmza ile İmzala",
    addNewCategory: "Yeni kategori ekle",
    autoRefreshJobList: "İş Listesi Otomatik Yenilensin",
    changeScriptRow: "Script sırasını değiştir",
    defaultRowCheckRequired: "Varsayılan satır varken zorunlu alan kontrolü yapılsın mı?",
    currentCode: "Cari Kodu",
    screenshotOnMobile: "Mobilde Ekran Görüntüsü Alma",
    showCallElement: "Arama butonunu göster",
    created: "Oluşturuldu",
    keepPermission: "Formu aktarırken izinleri de aktar.(Eğer kullanıcılarınız veya gruplarınız eşleşmiyorsa önerilmez)",
    showAddComponentButtonOnDragMenu: "Sol sürükleme menüsünde ekleme buttonu gösterilsin mi ?",
    editCategory: "Kategori ismini değiştir",
    confirmDeleteCategory: "Kategoriyi silmekten",
    formsWillMoveOnGeneral: "Silinen kategorinin altındaki formlar otomatik olarak 'Genel' klasörüne taşınacaktır.",
    disabledDates: "Engellenen Tarihler",
    fileLimitAndSizeRequired: "Dosya boyutu veya dosya sınırı boş bırakılmamalıdır",
    relatedFieldChangeDetected: "Bağlı veri değişimi algılandı. Değer temizlendi.",
    toastAnonimFormEmailWarning: "Anonim formlarda email bileşeni koyulması zorunludur.",
    toastAnonimFormEmailControlWarning: "Login Formu alanı aktifken Email alanı boş bırakılamaz.",
    startTrigger: "Başlatma Tetikleyicisi",
    stopTrigger: "Durdurma Tetikleyicisi",
    // Anket
    poll: "Anket",
    quickPoll: "Oylama",
    pollTitle: "Anket Başlığı",
    questionSection: "Soru Bölümü",
    options: "Seçenekler",
    enterYourQuestion: "Sorunuzu girin",
    option: "Seçenek",
    addOption: "Seçenek Ekle",
    selectGroups: "Grupları Seçin",
    yourQuestionWillAppearHere: "Sorunuz burada görünecektir",
    optionText: "Seçenek",
    pollVisibility: "Anket Görünürlüğü",
    visibleAnytime: "Her Zaman Görünür",
    visibleAfterExpiration: "Anket Bitiminde Görünür",
    isPostDeleted: "Gönderi silindi",
    totalVotes: "Toplam Oy",
    pollHasEnded: "Anket sonuçlanmıştır",
    pollResults: "Anket Sonuçları",
    objectFit: "Görsel Oran Ayarı",
    retweet: "Tekrar Paylaş",
    retweetNotAllowed: "Tekrar paylaşım yapılamaz",
    postHasBeenDeleted: "Gönderi silindi",
    post: "Gönderi",
    pollType: "Anket Tipi",
    retweetConfirmation: 'Bu gönderiyi retweet etmek istediğinizden emin misiniz?',
    addYourThoughts: 'Düşüncelerinizi ekleyin...',
    postContentTooLong: 'Gönderi içeriği 500 karakterden uzun olamaz',
    pollResultsVisibleAfterExpiration: "Sonuçlar anket bitiminden sonra görünür",
    pollResultsAnonymous: "Bu anket gizli. Sonuçlar görünmez.",
    loadingPosts: "Gönderiler yükleniyor...",
    generalPoll: "Genel Anket",
    // Bileşenler
    components: "Bileşenler",
    tabComponents: "Tab bileşenleri",
    allowFloating: "Yüzdürmeye izin ver",
    cellAspectRatio: "Hücre en boy oranı",
    cellSpacing: "Hücre aralığı",
    componentSpacing: "Bileşen aralığı",
    cellPaddingTop: "Hücre üst boşluğu",
    cellPaddingBottom: "Hücre alt boşluğu",
    selectedCardSettings: "Seçili Kart Ayarları",
    panelSettings: "Panel Ayarları",
    cannotDragMoreWidget: "Bir tab'a birden fazla widget ekleyemezsiniz.",
    carouselSpeed: "Slayt hızı (ms)",
    carouselMaxPauseOnHover: "Üzerine gelindiğinde maksimum duraklama (ms)",
    noContentInThisTab: "Bu tab'a henüz bir içerik eklenmemiştir.",
    pageTypeNotSelected: "Sayfa Tipi Seçilmedi. Bir içerik görüntülenmeyecektir.",
    folderSelectionWarning: "Klasör seçimi yaptınız. Bir içerik görüntülenmeyecektir.",
    menuDisplayUnsupported: "Menü görüntülemesi Sayfa tasarımcısında yapılamamaktadır.",
    noPageSelected: "Sayfa Seçimi Yapılmadı",
    design: "Tasarım",
    addCard: "Kart Ekle",
    noSettingsForThisWidget: "Bu bileşen için bir ayar bulunmamaktadır.",
    areYouSureForClosing: "Kapatmak istediğinize emin misiniz?",

    // Anket ile ilgili yeni çeviriler
    question: "Soru",
    multipleChoice: "Çoktan Seçmeli",
    allowMultiSelect: "Çoklu Seçime İzin Ver",
    openEnded: "Açık Uçlu",
    questionPlaceholder: "Soru metni buraya gelecek",
    optionPlaceholder: "Seçenek metni buraya gelecek",
    answerPlaceholder: "Cevabınızı buraya yazın",
    startAtFutureDate: "İleri Tarihte Başlat",
    createPost: "Gönderi Oluştur",
    enterYourAnswer: "Cevabınızı girin",
    submit: "Gönder",

    // Anket validasyon mesajları
    selectDateAndTime: "Tarih ve saat seçilmelidir",
    allQuestionsRequired: "Tüm sorular doldurulmalıdır",
    endDateRequired: "Bitiş tarihi seçilmelidir",
    allOptionsRequired: "Tüm seçenekler doldurulmalıdır",
    pollCreatedSuccessfully: "Anket başarıyla oluşturuldu",
    saveFailed: "Kaydetme işlemi başarısız",
    errorOccurred: "Bir hata oluştu",
    endDateMustBeAfterStart: "Bitiş tarihi başlangıç tarihinden sonra olmalıdır",
    createNewPoll: "Yeni Anket Oluştur",
    confirmDelete: "Bu anketi silmek istediğinizden emin misiniz?",
    pollDeleted: "Anket başarıyla silindi",
    expired: "Süresi Dolmuş",
    answerPoll: "Anketi Cevapla",
    Title: "Başlık",
    CreatedDate: "Oluşturulma Tarihi",
    endDate: "Bitiş Tarihi",
    status: "Durum",
    polls: "Anketler",
    viewResults: 'Sonuçları Görüntüle',
    responses: 'yanıt',
    mostPopularAnswers: 'En Popüler Cevaplar',
    pollNotStartedYet: 'Anket henüz başlamadı. Sonuçlar anket başladıktan sonra görüntülenebilecektir.',
    pollEndsIn: 'Anket bitimine kalan süre',
    days: 'gün',
    minutes: 'dakika',
    pollAnswered: 'Anket cevaplanmıştır',
    pollNotActive: 'Anket aktif değil',
    deletePostConfirmation: "Bu gönderiyi silmek istediğinizden emin misiniz?",
    editedByModerator: "Moderatör tarafından düzenlendi",
    errorDeletingPost: "Gönderi silinirken bir hata oluştu",
    errorUpdatingPost: "Gönderi güncellenirken bir hata oluştu",
    moderator: "Moderatör",
    postDeletedSuccessfully: "Gönderi başarıyla silindi",
    postUpdatedSuccessfully: "Gönderi başarıyla güncellendi",
    unauthorized: "Bu işlemi gerçekleştirmek için yetkiniz bulunmamaktadır",

    // Moderator Affairs ile ilgili çeviriler
    addTabsToAdd: "Eklenecek Sekmeler",
    ban: "Yasakla",
    banUsers: "Kullanıcıları Yasakla",
    designer: "Tasarımcı",
    moderatorAffairs: "Moderatör İşlemleri",
    pleaseSelectAtLeastOneTab: "Lütfen en az bir sekme seçiniz",
    pleaseSelectUsers: "Lütfen kullanıcı seçiniz",
    selectTabsToBan: "Yasaklanacak Sekmeleri Seçin",
    selectTabsToAdd: "Eklenecek Sekmeleri Seçin",
    selectUsers: "Kullanıcıları Seçin",
    selectedUsers: "Seçili Kullanıcılar",
    tabsAddedSuccessfully: "Sekmeler başarıyla eklendi",
    tabsRemovedSuccessfully: "Sekmeler başarıyla kaldırıldı",
    userList: "Kullanıcı Listesi",
    usersUpdatedSuccessfully: "Kullanıcılar başarıyla güncellendi",
    Role: "Rol",
    User: "Kullanıcı",
    All: "Tümü",
    Polls: "Anketler",
    Social: "Sosyal",
    Designer: "Tasarımcı",
    Moderator: "Moderatör",
    fullName: "Adı Soyadı",
    accessibleTabs: "Erişilebilen Sekmeler",
    banSelectedUsers: "Seçili Kullanıcıları Yasakla",
    roles: "Roller",
    superadmin: "Superadmin",
    admin: "Admin",
    accountBanned: "Hesabınız yasaklandı. Sistem yöneticisi ile iletişime geçin.",
    accountBannedFromCurrentTab: "Bu alandan erişiminiz kaldırıldı. Ana sayfaya yönlendiriliyorsunuz.",
    accountBannedFromAllTabs: "Tüm alanlardan erişiminiz kaldırıldı. Sistem yöneticisi ile iletişime geçin.",
    errorUpdatingUsers: "Kullanıcı güncellenirken bir hata oluştu",
    editPost: "Gönderiyi Düzenle",
    retweeted: "Tekrar Paylaşıldı",
    idNotNull: "Kimlik boş olamaz",
    changingFields: "Değişen Alanlar",
    createFlowInfo: "Süreç Başarıyla Başlatıldı",
    flowRestartedSuccessfully: "Süreç Başarıyla Yeniden Başlatıldı",
    flowIsSuccessfullyResumed: "Süreç Başarıyla İlerletildi",
    // ManagementSettings
    systemSettings: "Sistem Ayarları",
    databaseSettings: "Veritabanı Ayarları",
    mobileSettings: "Mobil Ayarları",
    loginPrefences: "Giriş Sayfası Ayarları",
    integrationSettings: "Entegrasyon Ayarları",
    // GeneralSettings
    IISAddress: "IIS Alan Adı",
    // CompanySettings
    // companySettings: "Şirket Ayarları",
    // companyName: "Şirket İsmi",
    // companyLogo: "Şirket Logo (data:content/type;base64)",
    // companyLogoLogin: "Şirket Logo Login Ekranı (data:content/type;base64)",
    // companyLoginBackground: "Şirket Login Ekranı Arkaplanı (data:content/type;base64)",
    // communicationSettings
    // communicationSettings: "İletişim Ayarları",
    SMTPAddressID: "Smtp Adresi Id",
    LogEmails: "Email Logları",
    // SecuritySettings
    SessionTimeout: "Oturum Zaman Aşımı",
    JWTTimeout: "JWT Zaman Aşımı",
    VRFFactor: "Doğrulama Faktörü",
    SyncFactor: "Senkronizasyon Faktörü",
    LoginFeaType: "Giriş Özellik Türü",
    MicrosoftAuthenticator: "Microsoft Kimlik Doğrulayıcı",
    LoginWithoutLook: "Görmeden Giriş",
    // ActiveDirectorySettings
    ADDomainName: "Active Directory Alan Adı",
    ADUserName: "Active Directory Kullanıcı Adı",
    ADPassword: "Active Directory Kullanıcı Şifresi",
    ADLogonType: "Active Directory Login Tipi",
    ADKrbProvider: "Active Directory Kerberos Sağlayıcısı",
    ADLoginType: "Active Directory Giriş Türü",
    HasLDAP: "LDAP Entegrasyonu Var mı?",
    // Other Settings
    Language: "Dil",
    SpecialCodeDescripts: "Özel Kod Açıklamaları",
    ReceiptHtml: "Fiş HTML İçeriği",
    ExchangeRateCodes: "Döviz Kuru Kodları",
    CustomMenuData: "Özel Menü Verileri",
    ForceBGScripts: "Zorunlu Arka Plan Komut Dosyaları",
    CanPost: "Gönderi Yapabilir",
    CanSearchUsers: "Kullanıcıları Arayabilir",
    // DbSettings
    connectionName: "Bağlantı Adı",
    serverName: "Sunucu Adı",
    databaseName: "Veritabanı Adı",
    databaseType: "Veritabanı Türü",
    portNo: "Bağlantı Noktası Numarası",
    isMainConn: "Ana Bağlantı mı?",
    isFileConn: "Dosya Bağlantısı mı?",
    test: "Test",
    // IntegrationSettings
    integrationName: "Entegrasyon Adı",
    integrationUrl: "Entegrasyon Url",
    integrationJson: "Entegrasyon JSON",
    isActive: "Aktif mi ?",
    disabled: "Engelli",
    // Login Preferences
    colors: "Renkler",
    primaryColor: "Ana renk",
    rightTextColor: "Sağ metin rengi",
    leftTextColor: "Sol metin rengi",
    rightBackgroundColor: "Sağ arka plan rengi",
    rightHeaderTextColor: "Sağ başlık metin rengi",
    logo: "Logo",
    logoHeight: "Logo yüksekliği",
    logoHeightHint: "Logo yüksekliği ipucu",
    logoPosition: "Logo konumu",
    company: "Şirket",
    companyLinkedinUrl: "Şirket linkedin adresi",
    enableNavigationRiver: "River navigasyonu etkin",
    enableNavigationLinkedIn: "Linkedin navigasyonu etkin",
    passwordSettings: "Şifre Ayarları",

    // oyanik
    schedulerSettingsInfo: "İlgili kanbanın takviminin görüntülenmesi için lütfen takvim ayarlarını yapınız.",
    urgentPri: "Acil",
    errorDeletedTaskUpd: "Silinmiş görevleri düzenlemek için yetkili değilsiniz.",
    openPoll: "Anketi Göster",

    // User form translations
    SearchUser: "Kullanıcı Ara",
    Inactive: "Pasif",
    AddNewUser: "Yeni Kullanıcı Ekle",
    WorkPhone: "İş Telefonu",
    Actions: "İşlemler",
    Deactivate: "Devre Dışı Bırak",
    Activate: "Etkinleştir",
    NewUser: "Yeni Kullanıcı",
    userNameRequired: "Kullanıcı Adı zorunludur",
    userNameMinLength: "Kullanıcı Adı en az 3 karakter olmalıdır",
    fullNameRequired: "Tam Ad zorunludur",
    companyNameRequired: "Şirket Adı zorunludur",
    defaultLanguage: "Varsayılan Dil",
    mobileLang: "Mobil Dil",
    EnterPassword: "Şifre Girin",
    PasswordRequired: "Şifre zorunludur",
    changePassword: "Şifreyi Değiştir",
    NewPassword: "Yeni Şifre",
    EnterNewPassword: "Yeni Şifre Girin",
    userGroups: "Kullanıcı Grupları",
    userGroupsDescription: "Kullanıcı Grupları Açıklaması",
    SelectUserGroups: "Kullanıcı Grupları Seçin",
    SelectManager: "Yönetici Seçin",
    webInTabs: "Web Sekmeleri",
    webInTabsDescription: "Web Sekmeleri Açıklaması",
    SelectWebInTabs: "Web Sekmeleri Seçin",
    SpecialCode1: "Özel Kod 1",
    SpecialCode2: "Özel Kod 2",
    SpecialCode3: "Özel Kod 3",
    SpecialCode4: "Özel Kod 4",
    SpecialCode5: "Özel Kod 5",
    mobilePhone: "Mobil Telefon",
    Company: "Şirket",
    isAdmin: "Admin mi?",
    isSuperAdmin: "Super Admin mi?",
    isDesigner: "Tasarımcı mı?",
    isModerator: "Moderatör mü?",
    isUser: "Kullanıcı mı?",
    isGuest: "Misafir mi?",
    isChatNotify: "Chat Bildirimleri",
    isBlue: "Mavi yakalı mı?",
    isAnon: "Anonim mi?",
    isMenuUser: "Menüde görünür mü?",
    hasPhoto: "Fotoğraf var mı?",
    canChat: "Chat yapabilir mi?",
    isDeleted: "Silindi mi?",
    manager: "Yönetici",
    Save: "Kaydet",
    Active: "Aktif",
    Deleted: "Silindi",
    SearchUserGroup: "Kullanıcı Grubu Ara",
    AddNewUserGroup: "Yeni Kullanıcı Grubu Ekle",
    GroupName: "Grup Adı",
    GroupDesc: "Grup Açıklaması",
    UserGroupForm: "Kullanıcı Grubu Formu",
    GroupInfo: "Grup Bilgisi",
    IsActive: "Aktif mi",
    SpecialCodes: "Özel Kodlar",
    Manager: "Yönetici",
    IsDeleted: "Silindi mi",
    Users: "Kullanıcılar",
    Export: "Dışarı Aktar",
    myChannels: "Kanallarım",
    taskHistoryWarning: "Süreç Geçmişi Bulunamadı!",
    //SOCIAL AND CHANNELS
    channels: "Kanallar",
    defaultAndFollowed: "Varsayılan Ve Takip Edilen",
    following: "Takip Edilen",
    publicChannels: "Açık Kanallar",
    privateChannels: "Gizli Kanallar",
    followRequests: "Takip İstekleri",
    invitationRequests: "Davetiye Talebi",
    noInvitationRequests: "Davetiye Talebi Yok",
    votes: "Oylar",
    inviteUsers: "Kullanıcı Davetleri",
    channelType: "Kanal Tipi",
    displayName: "Görünüm İsmi",
    editChannel: "Kanal Düzenle",
    noFollowRequests: "Takip İstekleri yok",
    createNewChannel: "Yeni Kanal Oluştur",
    userChannelRequiredInfo: "Kullanıcı Kanalı Gerekli Bilgiler",
    public: "Açık",
    private: "Gizli",
    defaultChannel: "Varsayılan Kanal",
    searchUsers: "Kullanıcılar Ara",
    profileImage: "Profil Fotoğrafı",
    completeSetup: "Kurulumu Tamamla",
    createChannel: "Kanal Oluştur",
    unfollow: "Takibi bırak",
    follow: "Takip et",
    cantFollowYourself: "Kendini takip edemezsin",
    requestSent: "İstek gönderildi",
    cancelRequest: "İsteği iptal et",
    wantsToFollowYou: "Seni takip etmek istiyor",
    youInvitedToFollow: "Seni takip etmeye davet etti",
    accept: "Kabul et",
    defaultChannelTypeInfo: "Varsayılan kanal türü bilgisi",
    enterChannelDescription: "Kanal açıklamasını girin",
    createDefaultChannel: "Varsayılan kanal oluştur",
    channelInformation: "Kanal bilgisi",
    channelDescription: "Kanal açıklaması",
    members: "Üyeler",
    filteredChannels: "Filtrelenmiş kanallar",
    pollNotAnswerable: "Bu ankete şu anda cevap verilemez",
    errorLoadingPollResults: "Anket sonuçları yüklenirken hata oluştu",
    openEndedResponses: "Açık uçlu yanıtlar",
    noPollResponses: "Henüz yanıt yok",
    noPollData: "Anket verisi bulunamadı",
    activePolls: "Aktif anketler",
    pinnedPost: "Sabitlenmiş gönderi",
    unpinPost: "Sabitlenmiş gönderiyi kaldır",
    pinPost: "Gönderiyi sabitle",
    originalPostDeleted: "Orijinal gönderi silinmiş",
    reposted: "Yeniden paylaşıldı",
    comments: "Yorumlar",
    videoNotSupported: "Video desteklenmiyor",
    filePreviewNotAvailable: "Dosya ön izlemesi mevcut değil",
    writeComment: "Yorum yaz",
    imageNotAvailable: "Görsel mevcut değil",
    downloadFile: "Dosyayı indir",
    pollValidation: "Anket başlığı en az 3 karakter olmalıdır",
    back: "Geri",
    questionValidation: "Soru metni en az 5 karakter olmalıdır",
    noRecommendedUsers: "Önerilen kullanıcı bulunamadı",
    noSuggestedPosts: "Önerilen gönderi bulunamadı",
    postSavedSuccessfully: "Gönderi Başarı ile Kaydedildi",
    errorSavingPost: "Gönderi Kaydedilirken Hata Oluştu",
    contentCannotBeEmpty: "İçerik boş olamaz",
    onlyAdminsCanPost: "Yalnızca yöneticiler gönderi paylaşabilir",
    duplicateOptionsNotAllowed: "Aynı seçenek birden fazla kez eklenemez",
    pleaseCompleteAllFields: "Lütfen tüm alanları eksiksiz doldurun",
    errorCreatingPoll: "Anket oluşturulurken bir hata oluştu",
    upcoming: "Yaklaşan",
    channelNameRequired: "Kanal adı zorunludur",
    errorLoadingUsers: "Kullanıcılar yüklenirken bir hata oluştu",
    selectAnalyticPage: "Analiz sayfasını seçin",
    allChannelTypes: "Tüm kanal türleri",
    errorLoadingChannels: "Kanallar yüklenirken bir hata oluştu",
    searchChannel: "Kanal Ara...",
    channel: "Kanal",
    createDate: "Oluşturulma Tarihi",
    noDataToDisplay: "Görüntülenecek veri bulunmamaktadır",
    postLiked: "Gönderi beğenildi",
    anonymous: "Anonim",
    postUnliked: "Gönderi beğenilmekten vazgeçildi",
    commentAddedSuccessfully: "Yorum başarıyla eklendi",
    commentLiked: "Yorum beğenildi",
    errorToggleCommentLike: "Yorum beğenisi değiştirilirken bir hata oluştu",
    //************************ */
    channelName: "Kanal Adı",
    createdAt: "Oluşturma Tarihi",
    security: "Güvenlik",

    //SYSTEM SETTINGS
    general: "Genel",
    iisAddress: "IIS Adres",
    sessionTimeout: "Oturum Zaman Aşımı",
    jwtTimeout: "JWT Zaman Aşımı",
    vrfFactor: "Doğrulama Faktörü",
    syncFactor: "Senkronizasyon Faktörü",
    companySettings: "Şirket Ayarları",
    companyName: "Şirket İsmi",
    companyLogo: "Şirket Logo (data:content/type;base64)",
    companyLogoLogin: "Şirket Logo Login Ekranı (data:content/type;base64)",
    companyLoginBackground: "Şirket Login Ekranı Arkaplanı (data:content/type;base64)",
    communicationSettings: "İletişim Ayarları",
    smtpAddressID: "Smtp Adresi Id",
    logEmails: "Email Logları",
    adDomainName: "Active Directory Alan Adı",
    adUserName: "Active Directory Kullanıcı Adı",
    adPassword: "Active Directory Kullanıcı Şifresi",
    adLogonType: "Active Directory Login Tipi",
    adKrbProvider: "Active Directory Kerberos Sağlayıcısı",
    adLoginType: "Active Directory Giriş Türü",
    hasLDAP: "LDAP Entegrasyonu Var mı?",
    english: "İngilizce",
    turkish: "Türkçe",
    specialCodeDescripts: "Özel Kod Açıklamaları",
    receiptHtml: "Fiş HTML İçeriği",
    exchangeRateCodes: "Döviz Kuru Kodları",
    customMenuData: "Özel Menü Verisi",
    forceBGScripts: "Arka Plan Scriptlerini Zorla",
    canPost: "Gönderi Paylaşabilir",
    canSearchUsers: "Kullanıcıları Arayabilir",
    mobileTwoFactorAuth: "Mobil 2 faktörlü kimlik doğrulama",
    allowUserSearch: "Kullanıcılar arama yapabilsin mi?",

    //EMAIL SETTINGS
    definition: "Tanım",
    smtpAddress: "SMTP Adresi",
    emailAddress: "E-posta Adresi",
    useSSL: "SSL Kullan",
    editMailSettings: "E-posta Ayarlarını Düzenle",
    newMailSettings: "Yeni E-posta Ayarları",
    exchangeServerDomain: "Exchange Sunucu Alan Adı",
    noSSLPort: "SSL'siz Port",
    sslOpAllowUnsafeLegacyRenegotiationProt: "Güvensiz Eski SSL Yeniden Pazarlık Protokolüne İzin Ver",
    emailPassword: "E-posta Şifresi",
    mailSettingsUpdatedSuccessfully: "Mail ayarları başarıyla güncellendi",
    mailSettingsAddedSuccessfully: "Mail ayarları başarıyla eklendi",
    deleteMailSettingsConfirmation: "Mail ayarlarını silmek istediğinize emin misiniz?",
    mailSettingsDeletedSuccessfully: "Mail ayarları başarıyla silindi",
    pleaseCheckRequiredFields: "Lütfen gerekli alanları kontrol edin",
    testEmail: "E-posta Test Et",
    enterTestEmailAddress: "Test e-postasının gönderileceği adresi girin",
    testEmailSentSuccessfully: "Test e-postası başarıyla gönderildi",
    pleaseEnterEmailAddress: "Lütfen e-posta adresi girin",
    pleaseEnterValidEmail: "Lütfen geçerli bir e-posta adresi girin",
    anErrorOccurred: "Bir hata oluştu",

    //DB SETTINGS
    dbSettingsCreatedSuccessfully: "Veritabanı ayarları başarıyla oluşturuldu",
    editDBSettings: "Veritabanı Ayarlarını Düzenle",
    newDBSettings: "Yeni Veritabanı Ayarları",
    deleteDBSettingsConfirmation: "Veritabanı ayarlarını silmek istediğinizden emin misiniz?",
    dbSettingsDeletedSuccessfully: "Veritabanı ayarları başarıyla silindi",
    dbSettingsUpdatedSuccessfully: "Veritabanı ayarları başarıyla güncellendi",

    //INTEGRATION SETTINGS
    newIntegrationSettings: "Yeni Entegrasyon Ayarları",
    editIntegrationSettings: "Entegrasyon ayarlarını düzenle",
    integrationSettingsCreatedSuccessfully: "Entegrasyon ayarları başarıyla oluşturuldu",
    integrationSettingsUpdatedSuccessfully: "Entegrasyon ayarları başarıyla güncellendi",
    deleteIntegrationSettingsConfirmation: "Entegrasyon ayarlarını silmek istediğinize emin misiniz?",
    integrationSettingsDeletedSuccessfully: "Entegrasyon ayarları başarıyla silindi",

    //PASSWORD SETTINGS
    notFoundPassword: "Db de şifre ayarları bulunmamaktadır. Lütfen kaydedin",
    minCharacter: "Min Karakter",
    passwordChangeFrequency: "Parola Degistirme Sıklığı (Gün)",
    passwordComplexity: "Parola Güvenlik Seviyesi",
    mixedCaseLetters: "Büyük-Küçük Harf",
    specialCharacter: "Özel Karakter",
    requireADigit: "Rakam Olsun Mu?",
    passwordCriteria: "Parola Gereksinimleri",

    //MOBILE SETTINGS
    smsToken: "SMS Token",
    smsUsername: "SMS Kullanıcı Adı",
    smsPassword: "SMS Şifresi",
    smsServiceName: "SMS Hizmet Adı",
    smsPhoneNumber: "SMS Telefon Numarası",
    gmapToken: "Google Maps Token",
    gtrToken: "GTR Token",
    gmlToken: "GML Token",
    gfrbToken: "GFRB Token",
    gdbToken: "GDB Token",
    gdbName: "GDB Adı",

    //LOGIN SETTINGS
    loginFeaType: "Giriş Özellik Türü",
    microsoftAuthenticator: "Microsoft Kimlik Doğrulayıcı",
    loginWithoutLook: "Görmeden Giriş",
    activeDirectory: "ActiveDirectory",
    sslPort: "SSL Port",
    loginTfaType: "Giriş İki Aşamalı Doğrulama Türü",

    voteSuccessful: "Oy Başarılı",
    errorSubmittingVote: "Oylama gönderilirken bir hata oluştu",
    pollExpired: "Anket süresi doldu",
    voteUpdated: "Oyunuz başarıyla güncellendi",
    errorUpdatingVote: "Oyunuzu güncellerken bir hata oluştu",

    //CHAT
    groupNameWarning: "Aynı isimde grup oluşturulamaz!",
    exit: "Çıkış",
    leaveChatGroup: "Gruptan Ayrıl",
    clearChatMessage: "Sohbeti Temizle",
    groupMember: "Grup Üyeleri",
    addMember: "Üye Ekle",
    chatClearWarning: "Sohbet başarı ile temizlenmiştir.",
    leaveGroupWarning: "Gruptan çıkma işlemi başarı ile gerçekleşti.",
    groupNameUserWarning: "Grup Adı ve Grup Kullanıcıları Boş Olamaz!",
    fileSizeWarning: "Dosya boyutu 100 KB'dan buyuk olamaz.",
    groupMemberRemove: "Grup üyesi başarı ile silinmiştir.",
    addGroupMemberWarning: "Grup üyesi başarı ile eklenmiştir.",
    trackChangesForWord: "Word'de değişiklikleri takip et",
    wordTrackChangesConfirm: "Word Değişiklik İzleme Onaylama/Reddetme",
    otherAuthorize: "Diğer Yetkiler",
    goToPasswordChangePanel: "Şifre Değiştirme Paneline Git",
    minFileCountLimit: "Minimum Dosya Adedi",
    minimumFileRequired: "Minimum dosya sayısı karşılanmamış",
    panelShadow: "Panele Gölge Eklensin mi?",
    badgeShadow: "Gölge Eklensin mi?",
    SyncfusionDiagram: "Syncfusion Diagram",

    //HEADER SETTINGS
    headerSettings: "Başlık Ayarları",
    wordWrap: "Kelime Kaydırma",

    //LIVE DATAGRID SETTINGS
    liveDatagrid: "Canlı Veri Tablosu",
    liveDataSettings: "Canlı Veri Ayarları",
    keyColumnHint: "Verileri tanımlamak için kullanılacak benzersiz sütun (örn: id, primary_key)",
    valueColumns: "Değer Sütunları",
    valueColumnsHint: "Değişim takibi yapılacak sayısal sütunlar",
    valueColumnPlaceholder: "Sütun adı (örn: price, amount)",
    numericOnly: "Sadece Sayısal",
    addValueColumn: "Sütun Ekle",
    removeValueColumn: "Sütunu Kaldır",
    invalidColumnName: "Geçersiz sütun adı. Sadece harf, sayı ve alt çizgi kullanın.",
    currencyHint: "Değerlerin gösterileceği para birimi (örn: ₺, $, €)",
    refreshInterval: "Yenileme Aralığı (ms)",
    refreshIntervalHint: "Verilerin ne sıklıkla güncelleneceği (milisaniye)",
    refreshEvery: "Her",
    testQuery: "Sorguyu Test Et",
    testQueryHint: "SQL sorgusunun çalışıp çalışmadığını kontrol edin",
    selectKeyColumn: "Anahtar sütun seçin",
    selectValueColumns: "Değer sütunlarını seçin",
    basicSettings: "Temel Ayarlar",
    increaseColor: "Artış Rengi",
    decreaseColor: "Azalış Rengi",
    increaseColorHint: "Değer arttığında gösterilecek renk",
    decreaseColorHint: "Değer azaldığında gösterilecek renk",
    resetToDefault: "Varsayılana Sıfırla",
    applyColors: "Renkleri Uygula",
    loadingData: "Veriler yükleniyor...",
    visualSettings: "Görsel Ayarlar",
    selectColumnToCustomize: "Özelleştirilecek Kolonu Seçin",
    columnVisualHint: "Seçili kolon için görsel ayarlar",
    fontSettings: "Font Ayarları",
    textAlign: "Metin Hizalama",
    animationSettings: "Animasyon Ayarları",
    animationDuration: "Animasyon Süresi",
    glowEffect: "Işıltı Efekti",
    glowEffectHint: "Değer değişiminde ışıltı efekti göster",
    iconSettings: "İkon Ayarları",
    showArrows: "Okları Göster",
    showPercentage: "Yüzdeyi Göster",
    resetColumnToDefault: "Kolonu Varsayılana Sıfırla",
    applyToColumn: "Kolona Uygula",
    copyToAllColumns: "Tüm Kolonlara Kopyala",
    livePreview: "Canlı Önizleme",
    selectColumnToCustomizeMessage: "Görsel ayarları özelleştirmek için bir kolon seçin.",
    columnColorSettings: "Kolon Renk Ayarları",

    useExternalText: "Dışarıdan Texti Değiştir",

    UsersList: "Kullanıcı Listesi",
    startHidden: "Açılışta Gizli",

    // PivotGrid Settings
    displaySettings: "Görüntüleme Ayarları",
    showGrid: "Grid Göster",
    showFieldChooser: "Alan Seçici Göster",
    allowFiltering: "Filtrelemeye İzin Ver",
    allowSorting: "Sıralamaya İzin Ver",
    allowExpandAll: "Tümünü Genişletmeye İzin Ver",
    showRowTotals: "Satır Toplamlarını Göster",
    showColumnTotals: "Sütun Toplamlarını Göster",
    showRowGrandTotals: "Satır Genel Toplamı Göster",
    showColumnGrandTotals: "Sütun Genel Toplamı Göster",
    rowHeaderLayout: "Satır Başlık Düzeni",
    showChart: "Grafik Göster",
    chartType: "Grafik Tipi",
    chartHeight: "Grafik Yüksekliği",
    pivotGridPreview: "PivotGrid Önizleme",
    fieldConfiguration: "Alan Yapılandırması",
    addField: "Alan Ekle",
    noFieldsConfigured: "Henüz alan yapılandırılmadı",
    caption: "Başlık",
    dataField: "Veri Alanı",
    area: "Alan",
    dataType: "Veri Tipi",
    summaryType: "Özet Tipi",
    fieldCaption: "Alan Başlığı",
    dataFieldName: "Veri Alanı Adı",
    chart: "Grafik",
    fields: "Alanlar",
    query: "Sorgu",
    pdfViewOpenNewPage: "Yeni sayfada aç",
    messageApproveKEPSignature: "Form kaydedilmeden önce, KEP imzalama modulü açılacak ve imzalamanız istenecek. Onaylıyor musunuz?",
  }
}
